import { useCallback, useEffect, useMemo, useState, useRef } from 'react';
import html2canvas from 'html2canvas';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import Rating from '@mui/material/Rating';
import { withStyles } from '@material-ui/core/styles';
import {
  IAllLandingBusiness,
  ILandingBusiness,
} from '../../interfaces/ILandingBusiness';
import { IPlayer } from '../../interfaces/IPlayer';
import { IClient } from '../../interfaces/IClient';
import { useLandingBusiness } from '../../hooks/useLandingBusiness';
import { getStateAbbreviation } from '../../utils/brazilianStates';
import { isLeadSameAsPlayer } from '../../utils/isLeadSameAsPlayer';
import { toStringArray } from '../../utils/toStringArray';
import { Loading } from '../../components/Loading';
import { HelmetComponent } from '../../components/Helmet';
import FGTS from '../../assets/images/FGTS.png';
import minhaCasaMinhaVida from '../../assets/images/minhaCasaMinhaVida.png';
// Recorte local (sem as margens transparentes do arquivo original) — deixa
// o selo visivelmente maior dentro da mesma caixa, sem depender do S3.
import habitacaoMercadoPopular from '../../assets/images/habitacaoMercadoPopular.png';
import habitacaoMercadoPopularInteresseSocial from '../../assets/images/habitacaoMercadoPopularInteresseSocial.png';
import { WhatsAppCapture } from '../Action/components/WhatsAppCapture';
import { api } from '../../server/api';
import { Notify } from '../../components/Notify';
import {
  MaskCPF,
  maskMoney,
  maskMoneyWithText,
  maskPhoneBR,
  isValidPhoneBR,
} from '../../utils/mask';
import { ImageModal } from './components/imageModal';
import { FeatureIcon } from './components/featureIcon';
import { ShareModal } from './components/shareModal';
import * as routes from '../../constants/Routes';
import { IFrameModal } from './components/iFrameModal';
import { useAuth } from '../../hooks/useAuth';
import cartazBackground from '../../assets/images/banner-print.png';
import { ShareButton } from '../../components/ShareButtons';
import { QrcodeWithPdf } from '../../components/QrcodeWithPdf';
import { Button } from '../../components/Button';
import { ModalPosterPrint } from '../../components/ModalPosterPrint';
import { ModalContact } from '../../components/ModalContact';
import { useRating } from '../../hooks/useRating';
import { ILead } from '../Action/interfaces';
import { PlayerAvatar } from '../../components/PlayerAvatar';
import { HomeFilters } from '../Home/components/HomeFilters';
import { getYouTubeEmbed } from '../../utils/getYouTubeEmbed';
import {
  APARTMENT_TYPES,
  formatSquareMeters,
} from '../../utils/apartmentTypes';
import {
  AiSignup,
  SignupPrefill,
  isAiSignupAvailable,
} from '../../features/ai-signup';

const StyledRating = withStyles({
  iconFilled: {
    color: '#ffc107',
  },
})(Rating);

function isZeroRange(value?: number | number[]) {
  return (Array.isArray(value) ? value : [value]).every((item) => !item);
}

export function LandingBusiness() {
  const navigate = useNavigate();
  const { playerId, bussinessId } = useParams();
  const [searchParams] = useSearchParams();
  const isAutoParam = searchParams.get('auto') === 'true';
  const { client, player, signed } = useAuth();
  const { getLandingBusinessPage, getLandingBusinessById } =
    useLandingBusiness();
  const { getRating, postRating, rating } = useRating();
  const [lbPlayer, setLbPlayer] = useState<IPlayer>();
  const [lbClient, setLbClient] = useState<IClient>();
  const [landingBusiness, setLandignBusiness] = useState<ILandingBusiness>();
  const [clientLandingBusiness, setClientLandingBusiness] =
    useState<IAllLandingBusiness[]>();
  const [filteredClientLandingBusiness, setFilteredClientLandingBusiness] =
    useState<IAllLandingBusiness[]>();
  const [activeFilterDescription, setActiveFilterDescription] =
    useState<string>('');
  const [noResultsForm, setNoResultsForm] = useState({
    name: '',
    phone: '',
    consent: false,
    submitting: false,
    submitted: false,
  });
  const noResultsRef = useRef<HTMLDivElement>(null);
  const recommendationsRef = useRef<HTMLDivElement>(null);
  const [showAllRecommendations, setShowAllRecommendations] =
    useState<boolean>(false);
  const [activeTab, setActiveTab] = useState<string>('apartment');
  const [loading, setLoading] = useState<boolean>(true);
  const [acceptedTerms, setAcceptedTerms] = useState<boolean>(false);
  const [isOpenWhatsAppCapture, setIsOpenWhatsAppCapture] = useState(false);
  const [leadName, setLeadName] = useState<string>();
  const [leadLastName, setLeadLastName] = useState<string>();
  const [leadPhone, setLeadPhone] = useState<string>();
  // Mostra o erro de telefone só depois que a pessoa sai do campo, para não
  // acusar erro enquanto ainda está digitando.
  const [leadPhoneTouched, setLeadPhoneTouched] = useState<boolean>(false);
  const [noResultsPhoneTouched, setNoResultsPhoneTouched] =
    useState<boolean>(false);
  const [leadEmail, setLeadEmail] = useState<string>();
  const [leadCpf, setLeadCpf] = useState<string>();
  const [lead, setLead] = useState<ILead>();
  // Dados do lead para o cadastro com IA; sobrevivem ao fechamento do modal.
  const [aiSignupPrefill, setAiSignupPrefill] = useState<SignupPrefill>();
  const [aiSignupOpenRequest, setAiSignupOpenRequest] = useState(0);
  const [like, setLike] = useState<boolean>(false);
  const [share, setShare] = useState<boolean>(false);
  const [shareModal, setShareModal] = useState<boolean>(false);
  const [posterModalIsOpen, setPosterModalIsOpen] = useState<boolean>(false);
  const [playingMaterialUrl, setPlayingMaterialUrl] = useState<string | null>(
    null
  );
  const [cartazCover, setCartazCover] = useState<any>({});
  const [selectedCoverIndex, setSelectedCoverIndex] = useState<number>(0);
  const [playerPhotoBase64, setPlayerPhotoBase64] = useState<string>('');
  const [blueprintModal, setBlueprintModal] = useState(false);
  const [iFrameModal, setIFrameModal] = useState(false);
  const [imageModal, setImageModal] = useState(false);
  const [loadingDelay, setLoadingDelay] = useState(true);
  const [contactModalIsOpen, setContactModalIsOpen] = useState(false);
  const [isDescriptionExpanded, setIsDescriptionExpanded] =
    useState<boolean>(false);
  const [showReadMore, setShowReadMore] = useState<boolean>(false);
  const [hostId, setHostId] = useState<string>('');
  const descriptionRef = useRef<HTMLDivElement>(null);
  const qrCodeRef = useRef<HTMLDivElement>(null);
  const lbVideoUrl = landingBusiness?.medias?.videoUrl ?? null;
  const lbEmbedUrl = lbVideoUrl
    ? getYouTubeEmbed(lbVideoUrl, {
        controls: true,
        autoplay: true,
        mute: false,
        loop: false,
      })
    : null;
  const lbIsYoutube = !!lbEmbedUrl;
  const lbVideoId = lbIsYoutube
    ? lbVideoUrl?.match(
        /(?:youtu\.be\/|youtube\.com\/(?:embed\/|watch\?v=|shorts\/))([A-Za-z0-9_-]{11})/
      )?.[1]
    : null;

  const images = useMemo(() => {
    if (
      activeTab === 'neighborhood' &&
      landingBusiness?.details?.location?.googleMapsLink
    )
      return undefined;
    if (
      (landingBusiness?.medias?.images?.housingUnitImages &&
        activeTab === 'apartment') ||
      activeTab === 'neighborhood'
    )
      return landingBusiness.medias.images.housingUnitImages;
    if (
      landingBusiness?.medias?.images?.commonAreasImages &&
      activeTab === 'condo'
    )
      return landingBusiness.medias.images.commonAreasImages;
  }, [activeTab, landingBusiness]);

  useEffect(() => {
    const fetchData = async () => {
      if (playerId) {
        const Lb = await getLandingBusinessPage(playerId, bussinessId);
        setLbPlayer(Lb.player);
        setLbClient(Lb.client);
        setLandignBusiness(Lb.landingBusiness);
        setClientLandingBusiness(Lb.clientLandingBusinesses);
        setFilteredClientLandingBusiness(Lb.clientLandingBusinesses);
        getRating(playerId);
        if (Lb.player?.regional === 'nao' && Lb.player?.hostId) {
          setHostId(Lb.player.hostId);
        }
        if (Lb.player?.regional === 'sim') {
          setHostId(Lb.player.id);
        }
        setLoading(false);
        addPageView(Lb.landingBusiness.id, Lb.client?.id);
      } else {
        const Lb = await getLandingBusinessById(bussinessId, player.id);
        setLandignBusiness(Lb);
        setLbPlayer(player);
        setLbClient(client);
        getRating(player.id);
        setLoading(false);
      }
    };

    fetchData();

    const timer = setTimeout(() => {
      setLoadingDelay(false);
    }, 3000);

    // Limpa o timeout se o componente for desmontado
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (landingBusiness?.details?.description.length > 200) {
      setShowReadMore(true);
    }
  }, [landingBusiness?.details?.description]);

  const downloadQRCode = () => {
    if (!qrCodeRef.current) return;
    html2canvas(qrCodeRef.current, { scale: 4 }).then((canvas) => {
      const a = document.createElement('a');
      a.href = canvas.toDataURL('image/png');
      a.download = `qrcode-${Date.now()}.png`;
      a.click();
    });
  };

  const generateBase64 = useCallback(async () => {
    if (!landingBusiness?.shareUrl || !client?.logoURL) {
      return;
    }

    // Cartaz usa apenas fotos do Condomínio como capa/mosaico (não da unidade
    // habitacional) — a capa padrão é a primeira imagem cadastrada em
    // "Imagens do condomínio", mas o corretor pode trocar no modal.
    const commonImages =
      landingBusiness?.medias?.images?.commonAreasImages || [];
    const allImages = commonImages.slice(0, 8);

    setSelectedCoverIndex(0);

    if (!allImages.length) return;

    try {
      const photoURL = (lbPlayer || player)?.photoURL;
      const [logoImgBase64, qrCodeBase64, photoBase64, imagesBase64] =
        await Promise.all([
          imageUrlToBase64(client.logoURL),
          imageUrlToBase64(
            `https://api.qrserver.com/v1/create-qr-code/?data=${landingBusiness.shareUrl}`
          ),
          photoURL
            ? imageUrlToBase64(photoURL).catch(() => photoURL)
            : Promise.resolve(''),
          Promise.all(
            allImages.map((url) => imageUrlToBase64(url).catch(() => url))
          ),
        ]);

      setPlayerPhotoBase64(photoBase64);
      setCartazCover({
        imageUrl: allImages[0],
        imgBase64: imagesBase64[0] || '',
        imageUrls: allImages,
        imagesBase64,
        logoImgBase64,
        qrCodeBase64,
        playerPhotoBase64: photoBase64,
      });
    } catch (error) {
      console.error('Error generating base64:', error);
    }
  }, [landingBusiness, client?.logoURL, lbPlayer, player]);

  const imageUrlToBase64 = async (url: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      if (!url) {
        reject(new Error('URL is required'));
        return;
      }

      const img = new Image();
      img.crossOrigin = 'anonymous';

      img.onload = () => {
        try {
          const canvas = document.createElement('canvas');
          canvas.width = img.width;
          canvas.height = img.height;
          const ctx = canvas.getContext('2d');
          if (!ctx) {
            reject(new Error('Failed to get canvas context'));
            return;
          }
          ctx.drawImage(img, 0, 0);
          try {
            resolve(canvas.toDataURL('image/png'));
          } catch (canvasError) {
            resolve(url);
          }
        } catch (error) {
          reject(error);
        }
      };

      img.onerror = () => {
        const imgRetry = new Image();
        imgRetry.onload = () => {
          try {
            const canvas = document.createElement('canvas');
            canvas.width = imgRetry.width;
            canvas.height = imgRetry.height;
            const ctx = canvas.getContext('2d');
            if (!ctx) {
              reject(new Error('Failed to get canvas context'));
              return;
            }
            ctx.drawImage(imgRetry, 0, 0);
            try {
              resolve(canvas.toDataURL('image/png'));
            } catch (canvasError) {
              resolve(url);
            }
          } catch (err) {
            reject(err);
          }
        };
        imgRetry.onerror = () => resolve(url);
        imgRetry.src = url;
      };

      img.src = url;
    });
  };

  // Reordena as imagens (base64) do cartaz colocando a capa escolhida em
  // primeiro lugar — PosterPrintLandingBusiness usa displayImages[0] como
  // hero e o restante (até 4) como mosaico.
  const cartazImagesBase64 = useMemo(() => {
    const arr: string[] = cartazCover?.imagesBase64 || [];
    if (!arr.length) return arr;
    const idx = Math.min(selectedCoverIndex, arr.length - 1);
    return [arr[idx], ...arr.filter((_, i) => i !== idx)].slice(0, 4);
  }, [cartazCover, selectedCoverIndex]);

  // Mover generateBase64 para um useEffect separado que depende de landingBusiness
  useEffect(() => {
    if (landingBusiness) {
      generateBase64();
    }
  }, [landingBusiness, generateBase64]);

  useEffect(() => {
    if (
      filteredClientLandingBusiness?.length === 0 &&
      (clientLandingBusiness?.length ?? 0) > 0
    ) {
      setTimeout(() => {
        noResultsRef.current?.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      }, 100);
    }
  }, [filteredClientLandingBusiness]);

  const handleFilterResult = (filtered: IAllLandingBusiness[]) => {
    setFilteredClientLandingBusiness(filtered);
    if (filtered.length > 0) {
      setTimeout(() => {
        recommendationsRef.current?.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      }, 100);
    }
  };

  // Ao entrar na página (sem filtro ativo) a lista de recomendações mostra só
  // as LPs da mesma cidade e região da LP atual; "Carregar mais" libera as
  // demais. Com filtro ativo vale o resultado do filtro, sem esse recorte.
  const recommendations = useMemo(() => {
    const all = filteredClientLandingBusiness ?? clientLandingBusiness ?? [];
    if (activeFilterDescription || showAllRecommendations) {
      return { visible: all, hasMore: false };
    }
    const normalize = (value?: string) => (value ?? '').trim().toLowerCase();
    const location = landingBusiness?.details?.location;
    const sameLocation = all.filter(
      (Lb) =>
        normalize(Lb.city) === normalize(location?.city) &&
        normalize(Lb.region) === normalize(location?.region)
    );
    // Sem nenhuma LP na mesma cidade/região, mostra todas em vez de uma seção
    // vazia só com o botão.
    if (sameLocation.length === 0) return { visible: all, hasMore: false };
    return { visible: sameLocation, hasMore: sameLocation.length < all.length };
  }, [
    filteredClientLandingBusiness,
    clientLandingBusiness,
    activeFilterDescription,
    showAllRecommendations,
    landingBusiness,
  ]);

  const saveNoResultsLead = async () => {
    if (!noResultsForm.name || !noResultsForm.phone || !noResultsForm.consent)
      return;

    if (!isValidPhoneBR(noResultsForm.phone)) {
      setNoResultsPhoneTouched(true);
      Notify('Informe um telefone válido com DDD.', 'error');
      return;
    }

    if (isLeadSameAsPlayer({ phone: `+55 ${noResultsForm.phone}` }, lbPlayer)) {
      Notify('Não é possível haver auto-indicação', 'warn');
      return;
    }

    setNoResultsForm((f) => ({ ...f, submitting: true }));
    try {
      const nameParts = noResultsForm.name.trim().split(' ');
      const leadData = {
        name: nameParts[0],
        lastname: nameParts.slice(1).join(' ') || '',
        email: '',
        phone: `+55 ${noResultsForm.phone}`,
        businessId: landingBusiness?.id,
        playerId: lbPlayer?.id,
        clientId: lbClient?.id,
        converted: false,
        leadToken:
          Math.random().toString(36).substr(2, 9) +
          Math.random().toString(36).substring(2, 9),
        acceptedTerms: 'true',
        businessName: 'Sem disponibilidade',
        description: activeFilterDescription
          ? `Filtros aplicados: ${activeFilterDescription}`
          : 'Filtrou mas não encontrou resultado',
        tags: [
          'sem-disponibilidade',
          ...(activeFilterDescription
            ? activeFilterDescription.split(' | ').map((f) => f.trim())
            : []),
        ],
      };
      await api.post('/create', {
        createFunctionality: 'registerLead',
        userType: 'consumer',
        lead: leadData,
        clientId: lbClient?.id,
        playerId: lbPlayer?.id,
        validationCode: '',
        urlOrigem: window.location.href,
      });
      setNoResultsForm((f) => ({ ...f, submitting: false, submitted: true }));
    } catch {
      setNoResultsForm((f) => ({ ...f, submitting: false }));
    }
  };

  const saveLead = useCallback(
    async (lead: any) => {
      if (
        isLeadSameAsPlayer(
          {
            email: lead.leadEmail,
            cpf: lead.leadCpf,
            phone: lead.leadPhone ? `+55 ${lead.leadPhone}` : undefined,
          },
          lbPlayer
        )
      ) {
        Notify('Não é possível haver auto-indicação', 'warn');
        return;
      }

      try {
        const leadData = {
          name: lead.leadName,
          lastname: lead.leadLastName,
          email: lead.leadEmail,
          phone: `+55 ${lead.leadPhone}`,
          businessId: landingBusiness.id,
          playerId: lbPlayer.id,
          clientId: lbClient.id,
          cpf: lead.leadCpf ? lead.leadCpf : undefined,
          converted: false,
          leadToken:
            Math.random().toString(36).substr(2, 9) +
            Math.random().toString(36).substring(2, 9),
          acceptedTerms: 'true',
          businessName: '',
          liked: like,
          shared: share,
        };
        const parameters = {
          createFunctionality: 'registerLead',
          userType: 'consumer',
          lead: leadData,
          clientId: lbClient.id,
          playerId: lbPlayer.id,
          validationCode: '',
          urlOrigem: window.location.href,
        };

        const { data } = await api.post('/create', parameters);

        if (data.success) {
          setIsOpenWhatsAppCapture(false);
          if (data.message === 'Os dados já se encontram em nossa base.') {
            Notify(
              'Seus dados já estão na plataforma. Logo entraremos em contato!',
              'alert'
            );
          } else {
            setLead(data.data);
            setAiSignupPrefill({
              name: [lead.leadName, lead.leadLastName || lead.lastname]
                .filter(Boolean)
                .join(' '),
              email: lead.leadEmail,
              phoneNumber: lead.leadPhone,
            });
            setContactModalIsOpen(true);
            Notify(
              'Seus dados foram enviados com sucesso! Entraremos em contato em breve.',
              'success'
            );
          }
        }
        if (data.message === 'Os dados já se encontram em nossa base.') {
          Notify(
            'Seus dados ja se encontram na nossa base de dados. Entraremos em contato em breve. ',
            'info'
          );
        } else if (!data.success) {
          throw Error;
        }
      } catch (error) {
        console.log('saveLead error: ', error);
        Notify(
          'Ocorreu um erro ao enviar seus dados. Por favor, tente novamente mais tarde.',
          'error'
        );
      }
    },
    [landingBusiness, lbPlayer, lbClient, like, share]
  );

  const sendLike = useCallback(async () => {
    try {
      const { data } = await api.patch(
        `/landing-business/likes/${landingBusiness.id}`
      );
      if (data) {
        setLandignBusiness({
          ...landingBusiness,
          stats: { ...landingBusiness.stats, likes: data.body.stats?.likes },
        });
      }
    } catch (error) {
      console.log('sendLike error: ', error);
    }
  }, [landingBusiness]);

  const sendShare = useCallback(async () => {
    try {
      const { data } = await api.patch(
        `/landing-business/shares/${landingBusiness.id}`
      );
      if (data) {
        setLandignBusiness({
          ...landingBusiness,
          stats: {
            ...landingBusiness.stats,
            shares: data.body.stats?.shares,
          },
        });
      }
    } catch (error) {
      console.log('sendShare error: ', error);
    }
  }, [landingBusiness]);

  const addPageView = async (landingBusinessId: string, clientId?: string) => {
    const parameters = {
      userType: 'client',
      updateFunctionality: 'addPageViews',
      landingBusinessId: landingBusinessId,
      playerId,
      clientId: clientId ?? lbClient?.id,
    };

    await api.post(`/update`, parameters);
  };

  const cleanGoogleStorageUrl = (url: string): string => {
    if (!url) return '';

    // Remove parâmetros de assinatura do Google Cloud Storage
    if (url.includes('storage.googleapis.com') && url.includes('?')) {
      return url.split('?')[0];
    }

    return url;
  };

  const getCleanImageUrls = () => {
    const images = landingBusiness?.medias?.images?.housingUnitImages;

    if (!images || !Array.isArray(images) || images.length === 0) {
      // Se não houver imagens do imóvel, use a imagem padrão/logo
      if (lbClient?.logoURL) {
        return [{ url: cleanGoogleStorageUrl(lbClient.logoURL) }];
      }
      return undefined;
    }

    return images.map((url) => ({
      url: cleanGoogleStorageUrl(url),
    }));
  };

  // Função para gerar descrição adequada
  const getPageDescription = () => {
    if (landingBusiness?.details?.description) {
      // Remove HTML tags e limita a 160 caracteres
      const plainText = landingBusiness.details.description
        .replace(/<[^>]*>/g, '')
        .replace(/\s+/g, ' ')
        .trim()
        .substring(0, 160);

      return plainText + (plainText.length === 160 ? '...' : '');
    }

    if (lbPlayer?.name && landingBusiness?.details?.name) {
      return `${lbPlayer.name} te convida para conhecer ${landingBusiness.details.name}`;
    }

    return `Conheça ${landingBusiness?.details?.name || 'esta oportunidade'} em ${landingBusiness?.details?.location?.city || ''}`;
  };

  return (
    <div>
      <HelmetComponent
        actionImages={getCleanImageUrls()}
        canonicalUrl={
          landingBusiness?.shareUrl ||
          `https://oqpwahom.web.app/landingBusiness/${landingBusiness?.id}`
        }
        pageDescription={getPageDescription()}
        tabTitle={landingBusiness?.details?.name || 'Oportunidade'}
        actionTitle={landingBusiness?.details?.name}
        playerName={lbPlayer?.name}
        companyName={lbClient?.companyName}
        clientLogoURL={cleanGoogleStorageUrl(lbClient?.logoURL || '')}
        clientFavicon={lbClient?.favIcon}
        primaryColor={lbClient?.primaryColor}
        secondaryColor={lbClient?.secondaryColor}
        googleAnalyticsIntegration={
          landingBusiness?.marketingIntegration?.isIntegrationGoogleAnalytics &&
          landingBusiness?.marketingIntegration.integrationGoogleAnalyticsCode
        }
        pixelIntegration={
          landingBusiness?.marketingIntegration?.isIntegrationPixel &&
          landingBusiness?.marketingIntegration.integrationPixelCode
        }
      />
      {loading && <Loading />}
      {!loading && (
        <>
          <div
            style={{
              padding: '15px 35px',
              backgroundColor: 'white',
            }}
          >
            {/* Header */}
            {playerId && !landingBusiness?.settings?.anonymous && (
              <>
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    marginBottom: '25px',
                  }}
                >
                  <img
                    src={lbClient.originalLogoClient}
                    alt="Logo"
                    style={{ height: '48px' }}
                  />
                </div>

                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                  }}
                >
                  <PlayerAvatar
                    photoURL={lbPlayer.photoURL}
                    playerId={lbPlayer.id}
                    clientUrl={lbClient?.clientUrl}
                    size={80}
                  />
                  <div
                    style={{
                      display: 'flex',
                      marginTop: '20px',
                    }}
                  >
                    <div
                      className="d-flex justify-content-center position-relative "
                      style={{
                        top: '-1 5px',
                        fontSize: '18px',
                        fontWeight: '500',
                        alignItems: 'center',
                        gap: '7px',
                      }}
                    >
                      <StyledRating
                        value={Number(rating?.averageRating)}
                        precision={0.1}
                        readOnly
                      />{' '}
                      {rating?.averageRating}
                    </div>
                  </div>
                  <h2
                    style={{
                      fontSize: '20px',
                      fontWeight: '600',
                      marginTop: '8px',
                      color: '#666',
                    }}
                  >
                    {lbPlayer.name}
                  </h2>
                  <p
                    style={{
                      color: '#666',
                    }}
                  >
                    tem uma{' '}
                    {lbPlayer.regional === 'sim' ? 'recomendação' : 'indicação'}{' '}
                    para você
                  </p>
                </div>
              </>
            )}

            {playerId &&
              (clientLandingBusiness?.length ?? 0) >= 1 &&
              (lbClient?.enableAdvancedFilters === true ||
                lbClient?.enableAdvancedFilters === 'true' ||
                lbClient?.enableAdvancedFilters === 'Sim' ||
                lbClient?.enableAdvancedFilters === 'sim') && (
                <div style={{ marginBottom: '12px' }}>
                  <HomeFilters
                    allLandingBusiness={clientLandingBusiness}
                    onFilter={handleFilterResult}
                    primaryColor={lbClient?.primaryColor}
                    onFiltersChange={setActiveFilterDescription}
                    showAllCities
                  />
                </div>
              )}

            {/* Main Image */}
            {loadingDelay ? (
              <div style={{ marginLeft: '-35px' }}>
                <Loading />
              </div>
            ) : (
              <>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    backgroundColor: `${lbClient.primaryColor}`,
                    color: 'white',
                    padding: '7px 12px',
                    marginRight: 'auto',
                    marginLeft: 'auto',
                    marginTop: '10px',
                    width: window.innerWidth > 768 ? '95%' : '90%',
                    borderRadius: '10px',
                    position: 'relative',
                  }}
                >
                  <span
                    style={{
                      fontSize: '15px',
                      fontWeight: '500',
                      width: '42%',
                      whiteSpace: 'nowrap',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                    }}
                  >
                    {landingBusiness.details.location.city}
                    {landingBusiness.details.location.state &&
                      landingBusiness.details.location.city &&
                      ' - '}
                    {getStateAbbreviation(
                      landingBusiness.details.location.state
                    )}
                  </span>
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      position: 'absolute',
                      left: '50%',
                      top: '15%',
                      transform: 'translate(-50%, -50%)',
                      borderRadius: '50%',
                      backgroundColor: `${lbClient.primaryColor}`,
                      padding: '25px 22px',
                      width: '20px',
                      height: '20px',
                    }}
                  >
                    <i
                      className="material-icons-outlined"
                      style={{
                        fontSize: '40px', // Tamanho do ícone
                        fontWeight: '100', // Diminui a espessura da linha
                      }}
                    >
                      location_on
                    </i>
                  </div>
                  <span
                    style={{
                      fontSize: '15px',
                      fontWeight: '500',
                      maxWidth: '42%',
                      justifyContent: 'flex-end',
                      whiteSpace: 'nowrap',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                    }}
                  >
                    {landingBusiness.details.location.region}
                    {landingBusiness.details.location.region &&
                      landingBusiness.details.location.neighborhood &&
                      ' - '}
                    {landingBusiness.details.location.neighborhood}
                  </span>
                </div>
                <div
                  className="col-sm-12 col-lg-12"
                  style={{
                    marginTop: '-10px',
                  }}
                >
                  <img
                    src={landingBusiness.medias?.images?.housingUnitImages[0]}
                    alt="Apartment"
                    style={{
                      width: '100%',
                      height: '400px',
                      objectFit: 'cover',
                      borderRadius: '16px',
                    }}
                  />
                </div>
                <div className="responsive-layout row flex-lg-row flex-column-reverse">
                  <div
                    className="col-sm-12 col-lg-8 p-3 border rounded-4"
                    style={{
                      padding: '24px',
                      backgroundColor: 'white',
                      boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                      borderRadius: '8px',
                      marginTop: '24px',
                    }}
                  >
                    <div className="d-block d-md-flex">
                      <div style={{ width: '85%' }}>
                        <h1
                          style={{
                            fontSize: '24px',
                            fontWeight: 'bold',
                            color: '#666',
                          }}
                        >
                          {landingBusiness.details.name}
                        </h1>
                        <div
                          style={{
                            color: '#666',
                            marginTop: '16px',
                            textAlign: 'justify',
                            position: 'relative',
                          }}
                        >
                          <div
                            ref={descriptionRef}
                            style={{
                              ...(!isDescriptionExpanded &&
                                showReadMore && {
                                  display: '-webkit-box',
                                  WebkitLineClamp: 3,
                                  WebkitBoxOrient: 'vertical',
                                  overflow: 'hidden',
                                }),
                            }}
                            dangerouslySetInnerHTML={{
                              __html:
                                landingBusiness.details.description?.replace(
                                  /\n/g,
                                  '<br />'
                                ),
                            }}
                          />
                          {showReadMore && !isDescriptionExpanded && (
                            <button
                              onClick={() => setIsDescriptionExpanded(true)}
                              style={{
                                marginTop: '8px',
                                color: lbClient.primaryColor,
                                background: 'none',
                                border: 'none',
                                cursor: 'pointer',
                                fontSize: '14px',
                                fontWeight: '600',
                                padding: '0',
                                textDecoration: 'underline',
                              }}
                            >
                              Ver mais
                            </button>
                          )}
                          {showReadMore && isDescriptionExpanded && (
                            <button
                              onClick={() => setIsDescriptionExpanded(false)}
                              style={{
                                marginTop: '8px',
                                color: lbClient.primaryColor,
                                background: 'none',
                                border: 'none',
                                cursor: 'pointer',
                                fontSize: '14px',
                                fontWeight: '600',
                                padding: '0',
                                textDecoration: 'underline',
                              }}
                            >
                              Ver menos
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                    {/* Tabs */}
                    <div
                      style={{
                        display: window.innerWidth <= 768 ? 'grid' : 'flex',
                        gap: '16px',
                        marginTop: '24px',
                      }}
                    >
                      {['apartment', 'condo', 'neighborhood'].map((tab) => (
                        <button
                          key={tab}
                          style={{
                            padding: '8px 16px',
                            cursor: 'pointer',
                            background: 'none',
                            borderRadius:
                              window.innerWidth <= 768 ? '10px' : null,
                            border:
                              window.innerWidth <= 768
                                ? '1px solid #dee2e6'
                                : 'none',
                            ...(activeTab === tab
                              ? {
                                  color: `${lbClient.primaryColor}`,
                                  border:
                                    window.innerWidth <= 768
                                      ? `2px solid ${lbClient.primaryColor}`
                                      : 'none',
                                  borderBottom: `2px solid ${lbClient.primaryColor}`,
                                }
                              : {
                                  color: '#666',
                                  borderBottom:
                                    window.innerWidth <= 768
                                      ? '2px solid #dee2e6'
                                      : 'none',
                                }),
                          }}
                          onClick={() => setActiveTab(tab)}
                        >
                          {tab === 'apartment'
                            ? 'A unidade'
                            : tab === 'condo'
                              ? 'O condomínio'
                              : 'A vizinhança'}
                        </button>
                      ))}
                    </div>
                    <div
                      style={{
                        gap: '10px',
                        width: '100%',
                        justifyContent: 'space-between',
                        marginTop: '24px',
                        borderTop: '1px solid #eee',
                        borderBottom: '1px solid #eee',
                        padding: '16px 0',
                      }}
                    >
                      {activeTab === 'apartment' && (
                        <div style={{ display: 'block' }}>
                          <div
                            style={{
                              display: 'flex',
                              flexWrap: 'wrap',
                              gap: '20px',
                            }}
                          >
                            {!!landingBusiness.details.squareMeters && (
                              <FeatureIcon
                                icon={'design_services'}
                                text={
                                  Array.isArray(
                                    landingBusiness.details.squareMeters
                                  )
                                    ? `${landingBusiness.details.squareMeters[0]} - ${landingBusiness.details.squareMeters[1]} m²`
                                    : `${landingBusiness.details.squareMeters} m²`
                                }
                              />
                            )}
                            {!!landingBusiness.details.suites && (
                              <FeatureIcon
                                icon={'door_sliding'}
                                text={
                                  Array.isArray(landingBusiness.details.suites)
                                    ? `${landingBusiness.details.suites[0]} - ${landingBusiness.details.suites[1]} ${landingBusiness.details.suites[1] === 1 ? 'suíte' : 'suítes'}`
                                    : `${landingBusiness.details.suites} ${landingBusiness.details.suites === 1 ? 'suíte' : 'suítes'}`
                                }
                              />
                            )}
                            {!isZeroRange(landingBusiness.details.bedrooms) && (
                              <FeatureIcon
                                icon={'meeting_room'}
                                text={
                                  Array.isArray(
                                    landingBusiness.details.bedrooms
                                  )
                                    ? `${landingBusiness.details.bedrooms[0]} - ${landingBusiness.details.bedrooms[1]} ${landingBusiness.details.bedrooms[1] === 1 ? 'quarto' : 'quartos'}`
                                    : `${landingBusiness.details.bedrooms} ${landingBusiness.details.bedrooms === 1 ? 'quarto' : 'quartos'}`
                                }
                              />
                            )}
                            {!!landingBusiness.details.bathrooms && (
                              <FeatureIcon
                                icon={'wc'}
                                text={`${landingBusiness.details.bathrooms} ${landingBusiness.details.bathrooms === 1 ? 'banheiro' : 'banheiros'}`}
                              />
                            )}
                            {!!landingBusiness.details.garage && (
                              <FeatureIcon
                                icon={'directions_car'}
                                text={
                                  Array.isArray(landingBusiness.details.garage)
                                    ? `${landingBusiness.details.garage[0]} - ${landingBusiness.details.garage[1]} ${landingBusiness.details.garage[1] === 1 ? 'vaga' : 'vagas'}`
                                    : `${landingBusiness.details.garage} ${landingBusiness.details.garage === 1 ? 'vaga' : 'vagas'}`
                                }
                              />
                            )}
                            {APARTMENT_TYPES.map(({ key, icon, label }) => {
                              if (!landingBusiness.details.apartmentType?.[key])
                                return null;
                              const squareMeters = formatSquareMeters(
                                landingBusiness.details
                                  .apartmentTypeSquareMeters?.[key]
                              );
                              return (
                                <FeatureIcon
                                  key={key}
                                  icon={icon}
                                  text={
                                    squareMeters
                                      ? `${label}, ${squareMeters}`
                                      : label
                                  }
                                />
                              );
                            })}
                          </div>
                        </div>
                      )}
                      {activeTab === 'condo' && (
                        <div style={{ display: 'block' }}>
                          <div
                            style={{
                              display: 'flex',
                              justifyContent: 'flex-start',
                              flexWrap: 'wrap',
                              gap: '20px',
                            }}
                          >
                            {landingBusiness.details.closedCondominium && (
                              <FeatureIcon
                                icon={'account_balance'}
                                text={'Condominio fechado'}
                              />
                            )}
                            {landingBusiness.details?.condominium &&
                              Object.entries(
                                landingBusiness.details.condominium
                              ).map(([key]) => (
                                <>
                                  {key === 'gym' && (
                                    <FeatureIcon
                                      icon={'directions_car'}
                                      text={'Academia'}
                                    />
                                  )}
                                  {key === 'petArea' && (
                                    <FeatureIcon
                                      icon={'pets'}
                                      text={'Area pet'}
                                    />
                                  )}
                                  {key === 'pool' && (
                                    <FeatureIcon
                                      icon={'pool'}
                                      text={'Piscina'}
                                    />
                                  )}
                                  {key === 'barbecueArea' && (
                                    <FeatureIcon
                                      icon={'outdoor_grill'}
                                      text={'Churrasqueira'}
                                    />
                                  )}
                                  {key === 'sportsCourt' && (
                                    <FeatureIcon
                                      icon={'sports_basketball'}
                                      text={'Quadra'}
                                    />
                                  )}
                                  {key === 'coworkingSpace' && (
                                    <FeatureIcon
                                      icon={'workspaces'}
                                      text={'Coworking'}
                                    />
                                  )}
                                  {key === 'bikeRack' && (
                                    <FeatureIcon
                                      icon={'pedal_bike'}
                                      text={'Bicicletário'}
                                    />
                                  )}
                                  {key === 'beautySalon' && (
                                    <FeatureIcon
                                      icon={'workspaces'}
                                      text={'Salão de beleza'}
                                    />
                                  )}
                                  {key === 'alwaysAvailableReception' && (
                                    <FeatureIcon
                                      icon={'lock'}
                                      text={'Portaria 24h'}
                                    />
                                  )}
                                  {key === 'multifunctionalSpace' && (
                                    <FeatureIcon
                                      icon={'fireplace'}
                                      text={'Espaço multiuso'}
                                    />
                                  )}
                                  {key === 'laundry' && (
                                    <FeatureIcon
                                      icon={'local_laundry_service'}
                                      text={'Lavanderia'}
                                    />
                                  )}
                                  {key === 'sauna' && (
                                    <FeatureIcon
                                      icon={'hot_tub'}
                                      text={'Sauna'}
                                    />
                                  )}
                                  {key === 'kidsPlayground' && (
                                    <FeatureIcon
                                      icon={'child_friendly'}
                                      text={'Playground'}
                                    />
                                  )}
                                  {key === 'miniMarket' && (
                                    <FeatureIcon
                                      icon={'local_convenience_store'}
                                      text={'Minimercado'}
                                    />
                                  )}
                                  {key === 'coveredGarage' && (
                                    <FeatureIcon
                                      icon={'garage'}
                                      text={'Garagem coberta'}
                                    />
                                  )}
                                  {key === 'partyRoom' && (
                                    <FeatureIcon
                                      icon={'celebration'}
                                      text={'Salão de festa'}
                                    />
                                  )}
                                </>
                              ))}
                            {toStringArray(
                              landingBusiness.details?.condominium?.others
                            ).map((item, index) => (
                              <div key={index} style={{ display: 'flex' }}>
                                <b
                                  style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                  }}
                                >
                                  <span
                                    style={{
                                      display: 'inline-block',
                                      width: '6px',
                                      height: '6px',
                                      borderRadius: '50%',
                                      backgroundColor: 'currentColor',
                                      marginRight: '8px',
                                      flexShrink: 0,
                                    }}
                                  />
                                  {item}
                                </b>
                              </div>
                            ))}
                          </div>
                        </div>
                      )}
                      {activeTab === 'neighborhood' && (
                        <div style={{ display: 'block' }}>
                          <div
                            style={{
                              display: 'flex',
                              justifyContent: 'flex-start',
                              flexWrap: 'wrap',
                              gap: '20px',
                            }}
                          >
                            {landingBusiness.details?.neighborhood &&
                              Object.entries(
                                landingBusiness.details.neighborhood
                              ).map(([key, value]) => (
                                <>
                                  {key === 'fruitMarkets' && value && (
                                    <FeatureIcon
                                      icon={'storefront'}
                                      text={'Sacolão'}
                                    />
                                  )}
                                  {key === 'gyms' && value && (
                                    <FeatureIcon
                                      icon={'fitness_center'}
                                      text={'Academias'}
                                    />
                                  )}
                                  {key === 'supermarkets' && value && (
                                    <FeatureIcon
                                      icon={'storefront'}
                                      text={'Supermercados'}
                                    />
                                  )}
                                  {key === 'subway' && value && (
                                    <FeatureIcon
                                      icon={'train'}
                                      text={'Metrô'}
                                    />
                                  )}
                                  {key === 'drugstores' && value && (
                                    <FeatureIcon
                                      icon={'medication'}
                                      text={'Farmácia'}
                                    />
                                  )}
                                  {key === 'daycares' && value && (
                                    <FeatureIcon
                                      icon={'child_care'}
                                      text={'Creche'}
                                    />
                                  )}
                                  {key === 'petshops' && value && (
                                    <FeatureIcon
                                      icon={'pets'}
                                      text={'Petshop'}
                                    />
                                  )}
                                  {key === 'easyAccess' && value && (
                                    <FeatureIcon
                                      icon={'accessible'}
                                      text={'Fácil acesso'}
                                    />
                                  )}
                                  {key === 'policeStations' && value && (
                                    <FeatureIcon
                                      icon={'local_police'}
                                      text={'Delegacia'}
                                    />
                                  )}
                                  {key === 'hospitals' && value && (
                                    <FeatureIcon
                                      icon={'monitor_heart'}
                                      text={'Hospitais'}
                                    />
                                  )}
                                  {key === 'busStops' && value && (
                                    <FeatureIcon
                                      icon={'directions_bus'}
                                      text={'Ponto de ônibus'}
                                    />
                                  )}
                                  {key === 'schools' && value && (
                                    <FeatureIcon
                                      icon={'school'}
                                      text={'Escolas'}
                                    />
                                  )}
                                </>
                              ))}
                            {toStringArray(
                              landingBusiness.details?.neighborhood?.others
                            ).map((item, index) => (
                              <div key={index} style={{ display: 'flex' }}>
                                <b
                                  style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                  }}
                                >
                                  <span
                                    style={{
                                      display: 'inline-block',
                                      width: '6px',
                                      height: '6px',
                                      borderRadius: '50%',
                                      backgroundColor: 'currentColor',
                                      marginRight: '8px',
                                      flexShrink: 0,
                                    }}
                                  />
                                  {item}
                                </b>
                              </div>
                            ))}
                          </div>
                          {!!landingBusiness.details.location
                            .googleMapsLink && (
                            <div
                              style={{
                                marginTop: '20px',
                              }}
                            >
                              <iframe
                                src={`https://www.google.com/maps/embed?pb=${landingBusiness.details.location.googleMapsLink}`}
                                width="100%"
                                height="450"
                                style={{ border: 0 }}
                                allowFullScreen={true}
                                loading="lazy"
                                referrerPolicy="no-referrer-when-downgrade"
                              />
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                    {images?.length > 0 && (
                      <div>
                        <a
                          style={{
                            display: 'grid',
                            gap: '5px',
                            width: '100%',
                            height: '500px',
                            margin: '0 auto',
                            borderRadius: '10px',
                            overflow: 'hidden',
                            background: 'none',
                            cursor: 'pointer',
                          }}
                          onClick={() => setImageModal(true)}
                        >
                          <div
                            style={{
                              backgroundColor: '#ccc',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              overflow: 'hidden',
                              gridColumn: '1 / 2',
                              gridRow: '1 / 3',
                            }}
                          >
                            <img
                              src={images[0]}
                              alt={`Imagem 1`}
                              style={{
                                width: '100%',
                                height: '100%',
                                objectFit: 'cover',
                              }}
                            />
                          </div>
                          {images.length > 1 && (
                            <div
                              style={{
                                backgroundColor: '#ccc',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                overflow: 'hidden',
                                gridColumn: '2 / 3',
                                gridRow: '1 / 2',
                              }}
                            >
                              <img
                                src={images[1]}
                                alt={`Imagem 2`}
                                style={{
                                  width: '100%',
                                  height: '100%',
                                  objectFit: 'cover',
                                }}
                              />
                            </div>
                          )}
                          {images.length > 2 && (
                            <div
                              style={{
                                backgroundColor: '#ccc',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                overflow: 'hidden',
                                gridColumn: '2 / 3',
                                gridRow: '2 / 2',
                              }}
                            >
                              <img
                                src={images[2]}
                                alt={`Imagem 3`}
                                style={{
                                  width: '100%',
                                  height: '100%',
                                  objectFit: 'cover',
                                }}
                              />
                            </div>
                          )}
                        </a>
                        <div
                          className="row"
                          style={{
                            display: 'flex',
                            marginTop: '19px',
                          }}
                        >
                          <div
                            className="col-12 col-sm-8"
                            style={{
                              display: 'flex',
                              gap: '15px',
                              marginBottom: '10px',
                              fontSize: '17px',
                            }}
                          >
                            {landingBusiness.medias.virtualTourUrl && (
                              <button
                                style={{
                                  display: 'flex',
                                  flexDirection:
                                    window.innerWidth <= 768
                                      ? 'column'
                                      : undefined,
                                  alignItems: 'center',
                                  padding: '10px',
                                  borderRadius: '10px',
                                  border: '1px solid #666666',
                                  backgroundColor: 'white',
                                }}
                                onClick={() => {
                                  window.open(
                                    `${landingBusiness.medias.virtualTourUrl}`,
                                    'blank'
                                  );
                                }}
                              >
                                <i className="material-icons-outlined">
                                  view_in_ar
                                </i>
                                3D Tour
                              </button>
                            )}
                            {landingBusiness.medias.videoUrl && (
                              <button
                                style={{
                                  display: 'flex',
                                  flexDirection:
                                    window.innerWidth <= 768
                                      ? 'column'
                                      : undefined,
                                  alignItems: 'center',
                                  padding: '10px',
                                  borderRadius: '10px',
                                  border: '1px solid #666666',
                                  backgroundColor: 'white',
                                }}
                                onClick={() =>
                                  window.open(
                                    `${landingBusiness.medias.videoUrl}`,
                                    'blank'
                                  )
                                }
                              >
                                <i className="material-icons-outlined">
                                  subscriptions
                                </i>
                                Videos
                              </button>
                            )}
                            {landingBusiness.medias.images.blueprintImages && (
                              <button
                                style={{
                                  display: 'flex',
                                  flexDirection:
                                    window.innerWidth <= 768
                                      ? 'column'
                                      : undefined,
                                  alignItems: 'center',
                                  padding: '10px',
                                  borderRadius: '10px',
                                  border: '1px solid #666666',
                                  backgroundColor: blueprintModal
                                    ? '#c04000'
                                    : 'white',
                                  color: blueprintModal ? 'white' : 'black',
                                }}
                                onClick={() => {
                                  setBlueprintModal(!blueprintModal);
                                  setImageModal(true);
                                }}
                              >
                                <i className="material-icons-outlined">
                                  square_foot
                                </i>
                                Planta
                              </button>
                            )}
                          </div>
                          <div
                            className="responsive-layout col-12 col-sm-4 d-flex justify-content-evenly justify-content-sm-end"
                            style={{
                              display: 'flex',
                              gap: '15px',
                              marginBottom: '10px',
                            }}
                          >
                            <div
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '10px',
                              }}
                            >
                              <button
                                style={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  padding: '10px',
                                  borderRadius: '100%',
                                  border: '1px solid #666666',
                                  backgroundColor: like ? '#c04000' : 'white',
                                  color: like ? 'white' : 'black',
                                }}
                                onClick={() => {
                                  if (like === false) {
                                    sendLike();
                                  }
                                  setLike(true);
                                }}
                                disabled={!playerId}
                              >
                                <i className="material-icons-outlined">
                                  favorite
                                </i>
                              </button>
                              {landingBusiness.stats?.likes
                                ? landingBusiness.stats?.likes
                                : '0'}
                            </div>
                            <div
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '10px',
                              }}
                            >
                              <button
                                style={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  padding: '10px',
                                  borderRadius: '100%',
                                  border: '1px solid #666666',
                                  backgroundColor: shareModal
                                    ? '#c04000'
                                    : 'white',
                                  color: shareModal ? 'white' : 'black',
                                }}
                                onClick={() => {
                                  sendShare();
                                  setShareModal(true);
                                  setShare(true);
                                }}
                                disabled={!playerId}
                              >
                                <i className="material-icons-outlined">share</i>
                              </button>
                              {landingBusiness.stats?.shares
                                ? landingBusiness.stats?.shares
                                : '0'}
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                    <hr
                      style={{
                        border: '1px solid #ccc',
                        width: '100%',
                        margin: '20px 0',
                      }}
                    />
                    <h1
                      style={{
                        fontSize: '24px',
                        fontWeight: 'bold',
                        color: '#666',
                        marginTop: '20px',
                      }}
                    >
                      Diferenciais
                    </h1>
                    <p
                      style={{
                        color: '#666',
                        marginTop: '16px',
                        textAlign: 'justify',
                        whiteSpace: 'pre-line',
                      }}
                    >
                      {landingBusiness.details?.location?.regionBenefits}
                    </p>
                  </div>

                  <div
                    className="col-sm-12 col-lg-4"
                    style={{ paddingLeft: '10px' }}
                  >
                    {/* Price Info */}
                    <div
                      style={{
                        position: 'relative',
                        marginBottom: window.innerWidth <= 768 ? '0' : '24px',
                        marginTop: window.innerWidth <= 768 ? '-15px' : '-30px',
                        borderRadius: '10px',
                        border:
                          window.innerWidth <= 768 ? null : '1px solid #dee2e6',
                        zIndex: '0',
                      }}
                    >
                      <div
                        style={{
                          backgroundColor: `${lbClient.primaryColor}`,
                          color: 'white',
                          borderRadius:
                            window.innerWidth <= 768
                              ? '8px'
                              : '8px 8px 0px 0px',
                          textAlign: 'center',
                          marginLeft: 'auto',
                          marginRight: 'auto',
                          width: window.innerWidth <= 768 ? '90%' : '100%',
                          overflow: 'hidden',
                        }}
                      >
                        <div
                          style={{
                            padding: '8px 24px 4px',
                            fontSize:
                              window.innerWidth <= 768 ? '17px' : '25px',
                            fontWeight: '500',
                          }}
                        >
                          {landingBusiness.details.constructionStage
                            ?.advancedConstruction && 'Obras Avançadas'}
                          {landingBusiness.details.constructionStage
                            ?.blueprint && 'Na Planta'}
                          {landingBusiness.details.constructionStage
                            ?.launched && 'Lançamento'}
                          {landingBusiness.details.constructionStage
                            ?.readyToMoveIn && 'Pronto para morar'}
                          {landingBusiness.details.constructionStage
                            ?.underConstruction && 'Em obras'}
                          {landingBusiness.details.constructionStage
                            ?.upcomingLaunch && 'Breve lançamento'}
                        </div>
                        {landingBusiness.details?.deliveryDate && (
                          <div
                            style={{
                              padding: '0 24px 8px',
                              fontSize:
                                window.innerWidth <= 768 ? '13px' : '16px',
                              fontWeight: '400',
                              opacity: 0.9,
                            }}
                          >
                            Entrega em:{' '}
                            {new Date(
                              landingBusiness.details.deliveryDate
                            ).toLocaleDateString('pt-BR', { timeZone: 'UTC' })}
                          </div>
                        )}
                      </div>
                      {landingBusiness.details?.type !== 'Alto padrao' && (
                        <div className="p-3">
                          <div
                            style={{
                              display: 'flex',
                              gap: '10px',
                              marginBottom: '20px',
                              justifyContent: 'space-around',
                            }}
                          >
                            {!!landingBusiness.customerPaymentConditions
                              ?.householdIncome && (
                              <div
                                style={{
                                  backgroundColor: `${lbClient.primaryColor}`,
                                  color: 'white',
                                  padding: '8px 15px',
                                  borderRadius: '8px',
                                  fontSize: '13px',
                                  textAlign: 'center',
                                  alignContent: 'center',
                                }}
                              >
                                Renda de até:
                                <h2
                                  style={{
                                    fontSize: '20px',
                                    fontWeight: '800',
                                    margin: '0',
                                    color: 'white',
                                  }}
                                >
                                  <span
                                    style={{
                                      fontSize: '15px',
                                      fontWeight: '500',
                                    }}
                                  >
                                    R$
                                  </span>{' '}
                                  {maskMoney(
                                    landingBusiness.customerPaymentConditions
                                      ?.householdIncome
                                  )}
                                </h2>
                                por mês
                              </div>
                            )}
                            {!!landingBusiness.customerPaymentConditions
                              ?.maximumSubsidy && (
                              <div
                                style={{
                                  backgroundColor: `${lbClient.primaryColor}`,
                                  color: 'white',
                                  padding: '8px 15px',
                                  borderRadius: '8px',
                                  fontSize: '13px',
                                  textAlign: 'center',
                                  alignContent: 'center',
                                }}
                              >
                                Subsídio de até:
                                <h2
                                  style={{
                                    fontSize: '20px',
                                    fontWeight: '800',
                                    margin: '0',
                                    color: 'white',
                                  }}
                                >
                                  <span
                                    style={{
                                      fontSize: '15px',
                                      fontWeight: '500',
                                    }}
                                  >
                                    R$
                                  </span>
                                  {maskMoney(
                                    landingBusiness.customerPaymentConditions
                                      ?.maximumSubsidy
                                  )}
                                </h2>
                              </div>
                            )}
                          </div>
                          <div
                            style={{
                              display: 'grid',
                              gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
                              justifyItems: 'center',
                              alignItems: 'center',
                              gap: '10px',
                            }}
                          >
                            {/* No máximo 2 selos por linha — se tiver uma 3ª
                                (ou as 4), quebra pra linha de baixo. Cada
                                selo cresce até preencher a metade disponível
                                da largura, então fica sempre legível. */}
                            {landingBusiness.details.paymentConditions
                              ?.minhaCasaMinhaVida && (
                              <img
                                style={{
                                  width: '100%',
                                  maxWidth: '140px',
                                  objectFit: 'contain',
                                }}
                                src={minhaCasaMinhaVida}
                                alt="Minha Casa Minha Vida"
                              />
                            )}
                            {landingBusiness.details.paymentConditions
                              ?.fgts && (
                              <img
                                style={{
                                  width: '100%',
                                  maxWidth: '140px',
                                  objectFit: 'contain',
                                }}
                                src={FGTS}
                                alt="FGTS"
                              />
                            )}
                            {landingBusiness.details.paymentConditions
                              ?.podeEntrar && (
                              <img
                                style={{
                                  width: '100%',
                                  maxWidth: '140px',
                                  objectFit: 'contain',
                                }}
                                src={habitacaoMercadoPopular}
                                alt="Habitação de Mercado Popular"
                              />
                            )}
                            {landingBusiness.details.paymentConditions
                              ?.casaVerdeAmarela && (
                              <img
                                style={{
                                  width: '100%',
                                  maxWidth: '140px',
                                  objectFit: 'contain',
                                }}
                                src={habitacaoMercadoPopularInteresseSocial}
                                alt="Habitação de Mercado Popular e Habitação de Interesse Social"
                              />
                            )}
                          </div>
                        </div>
                      )}
                      {landingBusiness.details?.type === 'Alto padrao' && (
                        <div className="p-3">
                          <div
                            className="d-flex flex-column flex-lg-row"
                            style={{
                              display: 'flex',
                              gap: '10px',
                              marginBottom: '20px',
                              justifyContent: 'space-around',
                            }}
                          >
                            {!!landingBusiness.customerPaymentConditions
                              ?.unitsMinimumValue && (
                              <div
                                style={{
                                  backgroundColor: `${lbClient.primaryColor}`,
                                  color: 'white',
                                  padding: '8px 15px',
                                  borderRadius: '8px',
                                  fontSize: '13px',
                                  textAlign: 'center',
                                  alignContent: 'center',
                                }}
                              >
                                Unidades a partir de:
                                <h2
                                  style={{
                                    fontSize: '20px',
                                    fontWeight: '800',
                                    margin: '0',
                                    color: 'white',
                                  }}
                                >
                                  <span
                                    style={{
                                      fontSize: '15px',
                                      fontWeight: '500',
                                    }}
                                  >
                                    R$
                                  </span>{' '}
                                  {maskMoneyWithText(
                                    landingBusiness?.customerPaymentConditions
                                      ?.unitsMinimumValue
                                  )}{' '}
                                  {!!landingBusiness?.customerPaymentConditions
                                    ?.unitsMaximumValue && (
                                    <>
                                      <span
                                        style={{
                                          fontSize: '15px',
                                          fontWeight: '500',
                                        }}
                                      >
                                        até R${' '}
                                      </span>
                                      {maskMoneyWithText(
                                        landingBusiness
                                          .customerPaymentConditions
                                          ?.unitsMaximumValue
                                      )}
                                    </>
                                  )}
                                </h2>
                              </div>
                            )}
                            {!!landingBusiness.customerPaymentConditions
                              ?.installmentsMinimumValue && (
                              <div
                                style={{
                                  backgroundColor: `${lbClient.primaryColor}`,
                                  color: 'white',
                                  padding: '8px 15px',
                                  borderRadius: '8px',
                                  fontSize: '13px',
                                  textAlign: 'center',
                                  alignContent: 'center',
                                }}
                              >
                                Parcelas mensais a partir de:
                                <h2
                                  style={{
                                    fontSize: '20px',
                                    fontWeight: '800',
                                    margin: '0',
                                    color: 'white',
                                  }}
                                >
                                  <span
                                    style={{
                                      fontSize: '15px',
                                      fontWeight: '500',
                                    }}
                                  >
                                    R${' '}
                                  </span>
                                  {maskMoney(
                                    landingBusiness.customerPaymentConditions
                                      ?.installmentsMinimumValue
                                  )}
                                </h2>
                              </div>
                            )}
                          </div>
                        </div>
                      )}
                    </div>

                    {(playerId ||
                      (landingBusiness?.settings?.autoIndication === true &&
                        isAutoParam)) && (
                      <>
                        <div className="p-3 border rounded-4">
                          {/* Contact Form */}
                          <div
                            style={{
                              borderRadius: '8px',
                            }}
                          >
                            {!!lbClient.originalLogoClient && (
                              <div
                                style={{
                                  display: 'flex',
                                  justifyContent: 'center',
                                  marginBottom: '10px',
                                }}
                              >
                                <img
                                  src={lbClient.originalLogoClient}
                                  alt="Logo do Programa"
                                  style={{ height: '48px' }}
                                />
                              </div>
                            )}
                            <h3
                              style={{
                                fontSize: '20px',
                                fontWeight: 'bold',
                                textAlign: 'center',
                                color: `${lbClient.primaryColor}`,
                              }}
                            >
                              {landingBusiness?.settings?.autoIndication
                                ? 'Registrar Lead'
                                : 'Solicitar Contato'}
                            </h3>
                            <div
                              style={{
                                display: 'grid',
                                gridTemplateColumns: '1fr 1fr',
                                gap: '16px',
                              }}
                            >
                              <input
                                type="text"
                                placeholder="Nome"
                                style={{
                                  padding: '8px',
                                  borderRadius: '4px',
                                  backgroundColor: '#00000010',
                                  border: 'none',
                                  width: '100%',
                                  marginTop: '16px',
                                }}
                                value={leadName}
                                onChange={(event) => {
                                  setLeadName(event.target.value);
                                }}
                              />
                              <input
                                type="text"
                                placeholder="Sobrenome"
                                style={{
                                  padding: '8px',
                                  borderRadius: '4px',
                                  backgroundColor: '#00000010',
                                  border: 'none',
                                  width: '100%',
                                  marginTop: '16px',
                                }}
                                value={leadLastName}
                                onChange={(event) => {
                                  setLeadLastName(event.target.value);
                                }}
                              />
                            </div>
                            <input
                              type="email"
                              placeholder="Email"
                              style={{
                                padding: '8px',
                                borderRadius: '4px',
                                backgroundColor: '#00000010',
                                border: 'none',
                                width: '100%',
                                marginTop: '16px',
                              }}
                              value={leadEmail}
                              onChange={(event) => {
                                setLeadEmail(event.target.value);
                              }}
                            />
                            <input
                              type="tel"
                              placeholder="Telefone/WhatsApp com DDD"
                              style={{
                                padding: '8px',
                                borderRadius: '4px',
                                backgroundColor: '#00000010',
                                border:
                                  leadPhoneTouched &&
                                  !!leadPhone &&
                                  !isValidPhoneBR(leadPhone)
                                    ? '1.5px solid #c62828'
                                    : 'none',
                                width: '100%',
                                marginTop: '16px',
                              }}
                              value={leadPhone}
                              inputMode="numeric"
                              autoComplete="tel-national"
                              pattern="^\(\d{2}\)\s\d{4,5}-\d{4}$"
                              aria-invalid={
                                leadPhoneTouched &&
                                !!leadPhone &&
                                !isValidPhoneBR(leadPhone)
                              }
                              onChange={(event) => {
                                setLeadPhone(maskPhoneBR(event.target.value));
                              }}
                              onBlur={() => setLeadPhoneTouched(true)}
                            />
                            {leadPhoneTouched &&
                              !!leadPhone &&
                              !isValidPhoneBR(leadPhone) && (
                                <span
                                  style={{
                                    display: 'block',
                                    color: '#c62828',
                                    fontSize: '12px',
                                    marginTop: '4px',
                                  }}
                                >
                                  Telefone inválido. Use o formato (11)
                                  98877-6655 ou (11) 8877-6655.
                                </span>
                              )}
                            {lbClient &&
                              lbClient.customFormLead &&
                              lbClient.customFormLead.cpf &&
                              lbClient.customFormLead.cpf === 'true' && (
                                <input
                                  type="cpf"
                                  placeholder="CPF"
                                  style={{
                                    padding: '8px',
                                    borderRadius: '4px',
                                    backgroundColor: '#00000010',
                                    border: 'none',
                                    width: '100%',
                                    marginTop: '16px',
                                  }}
                                  maxLength={14}
                                  value={MaskCPF(leadCpf)}
                                  onChange={(event) => {
                                    const digitsOnly = event.target.value
                                      .replace(/\D/g, '')
                                      .slice(0, 11);
                                    setLeadCpf(digitsOnly);
                                  }}
                                />
                              )}
                            <div
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                                marginTop: '16px',
                                fontSize: '14px',
                                color: '#666',
                              }}
                            >
                              <div
                                style={{
                                  marginRight: '10px',
                                  width: '20px',
                                  height: '20px',
                                  marginBottom: 'auto',
                                }}
                              >
                                <input
                                  className={`form-check-input`}
                                  style={{
                                    border: `2px solid ${lbClient.primaryColor}`,
                                  }}
                                  type="checkbox"
                                  value=""
                                  id="flexCheckDefault"
                                  onClick={() => {
                                    setAcceptedTerms(!acceptedTerms);
                                  }}
                                  checked={acceptedTerms}
                                />
                              </div>
                              <p style={{ textAlign: 'justify' }}>
                                De acordo com as Leis 12.965/2014 e 13.709/2018,
                                que regulam o uso da Internet e o tratamento de
                                dados pessoais no Brasil, ao autorizo{' '}
                                {lbClient?.companyName
                                  ? lbClient?.companyName
                                  : 'OQ Digital'}{' '}
                                a enviar notificações por e-mail ou outros meios
                                e concordo com sua{' '}
                                <a
                                  target="_blank"
                                  href="https://firebasestorage.googleapis.com/v0/b/oqhomapi.appspot.com/o/TermsAndPolitics%2FPOLI%CC%81TICA%20DE%20PRIVACIDADE%20LGPD%20COMPLIANCE%202026.pdf?alt=media&token=f6339049-9c75-4ac2-8417-a70c9d75be94"
                                >
                                  Política de Privacidade
                                </a>{' '}
                                e{' '}
                                <a
                                  onClick={() =>
                                    navigate(`${routes.TERMS}`, {
                                      state: {
                                        isCameFromActionPage: true,
                                        clientId: lbClient?.id,
                                      },
                                    })
                                  }
                                  style={{ color: 'blue', cursor: 'pointer' }}
                                >
                                  Termos de uso
                                </a>
                                .
                              </p>
                            </div>
                            <button
                              style={{
                                width: '100%',
                                backgroundColor: `${lbClient.primaryColor}`,
                                color: 'white',
                                padding: '12px',
                                borderRadius: '4px',
                                border: 'none',
                                marginTop: '16px',
                                cursor: 'pointer',
                              }}
                              disabled={
                                !acceptedTerms ||
                                !leadName ||
                                !leadLastName ||
                                !isValidPhoneBR(leadPhone || '') ||
                                !leadEmail ||
                                (client &&
                                  client.customFormLead &&
                                  client.customFormLead.cpf &&
                                  client.customFormLead.cpf === 'true' &&
                                  !leadCpf)
                              }
                              onClick={() => {
                                const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                                if (!emailRegex.test(leadEmail)) {
                                  Notify(
                                    'Por favor, insira um email válido.',
                                    'error'
                                  );
                                } else if (!isValidPhoneBR(leadPhone || '')) {
                                  setLeadPhoneTouched(true);
                                  Notify(
                                    'Informe um telefone válido com DDD.',
                                    'error'
                                  );
                                } else {
                                  saveLead({
                                    leadName,
                                    leadLastName,
                                    leadPhone,
                                    leadEmail,
                                    leadCpf,
                                  });
                                }
                              }}
                            >
                              {landingBusiness?.settings?.autoIndication
                                ? 'REGISTRAR LEAD'
                                : 'SOLICITAR CONTATO'}
                            </button>
                          </div>
                        </div>
                        <div
                          style={{
                            textAlign: 'center',
                            padding: '10px',
                            fontSize: '10px',
                          }}
                        >
                          <p
                            style={{
                              color: 'green',
                              display: 'flex',
                              justifyContent: 'center',
                              alignItems: 'center',
                              gap: '4px',
                            }}
                          >
                            <i className="material-icons-outlined fs-6">lock</i>{' '}
                            Este é um ambiente seguro!
                          </p>
                          <p>
                            Trabalhamos constantemente para proteger sua
                            segurança e privacidade.{' '}
                            <a
                              target="_blank"
                              href="https://firebasestorage.googleapis.com/v0/b/oqhomapi.appspot.com/o/TermsAndPolitics%2FPOLI%CC%81TICA%20DE%20PRIVACIDADE%20LGPD%20COMPLIANCE%202026.pdf?alt=media&token=f6339049-9c75-4ac2-8417-a70c9d75be94"
                            >
                              Saiba mais
                            </a>
                          </p>
                        </div>
                      </>
                    )}
                    {!playerId &&
                      landingBusiness?.medias?.supportMaterials &&
                      !isAutoParam &&
                      (lbPlayer || player)?.regional === 'sim' && (
                        <div
                          style={{
                            background: '#FBF7F2',
                            border: '1.5px solid #F0D9BC',
                            borderRadius: '16px',
                            padding: '12px',
                            marginBottom: '18px',
                          }}
                        >
                          <div
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: '6px',
                              fontSize: '11px',
                              fontWeight: 700,
                              color: '#A85E15',
                              textTransform: 'uppercase',
                              marginBottom: '12px',
                              letterSpacing: '0.04em',
                            }}
                          >
                            <span
                              style={{
                                width: '6px',
                                height: '6px',
                                borderRadius: '50%',
                                background: '#D9822B',
                                display: 'inline-block',
                                flexShrink: 0,
                              }}
                            />
                            Não compartilhável · restrito ao time de vendas
                          </div>
                          <div
                            style={{
                              backgroundColor: `${lbClient.primaryColor}`,
                              color: 'white',
                              padding: '8px 24px',
                              borderRadius: '8px',
                              fontSize:
                                window.innerWidth <= 768 ? '17px' : '20px',
                              fontWeight: '500',
                              textAlign: 'center',
                              marginBottom: '12px',
                            }}
                          >
                            Material de apoio ao corretor
                          </div>
                          <div
                            style={{
                              marginBottom: '12px',
                              color: '#666',
                              fontSize: '14px',
                              textAlign: 'center',
                            }}
                          >
                            Acesse aqui todo o material para ajudar você na
                            negociação e facilitar o fechamento do negócio.
                          </div>

                          {lbVideoUrl &&
                            (() => {
                              const isLbPlaying =
                                playingMaterialUrl === lbVideoUrl;
                              return (
                                <div
                                  style={{
                                    marginBottom: '12px',
                                    borderRadius: '10px',
                                    overflow: 'hidden',
                                    border: '1px solid #e8d5bb',
                                  }}
                                >
                                  {isLbPlaying ? (
                                    lbIsYoutube && lbEmbedUrl ? (
                                      <div className="ratio ratio-16x9">
                                        <iframe
                                          src={lbEmbedUrl}
                                          title="Vídeo do empreendimento"
                                          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                          allowFullScreen
                                        />
                                      </div>
                                    ) : (
                                      <div className="ratio ratio-16x9">
                                        <video
                                          src={lbVideoUrl}
                                          controls
                                          autoPlay
                                          style={{
                                            width: '100%',
                                            height: '100%',
                                            objectFit: 'contain',
                                          }}
                                        />
                                      </div>
                                    )
                                  ) : (
                                    <div
                                      style={{
                                        position: 'relative',
                                        cursor: 'pointer',
                                        background: '#1a1a1a',
                                        aspectRatio: '16/9',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        overflow: 'hidden',
                                      }}
                                      onClick={() =>
                                        setPlayingMaterialUrl(lbVideoUrl)
                                      }
                                    >
                                      {lbIsYoutube && lbVideoId && (
                                        <img
                                          src={`https://img.youtube.com/vi/${lbVideoId}/hqdefault.jpg`}
                                          alt="Vídeo do empreendimento"
                                          style={{
                                            width: '100%',
                                            objectFit: 'cover',
                                            position: 'absolute',
                                            inset: 0,
                                          }}
                                        />
                                      )}
                                      <div
                                        style={{
                                          position: 'absolute',
                                          inset: 0,
                                          background:
                                            'linear-gradient(to bottom, rgba(0,0,0,0.35) 0%, rgba(0,0,0,0.55) 100%)',
                                          display: 'flex',
                                          flexDirection: 'column',
                                          alignItems: 'center',
                                          justifyContent: 'center',
                                          gap: '8px',
                                        }}
                                      >
                                        <div
                                          style={{
                                            position: 'absolute',
                                            top: '10px',
                                            left: '10px',
                                            background:
                                              'rgba(255,255,255,0.18)',
                                            color: '#fff',
                                            fontSize: '10px',
                                            fontWeight: 700,
                                            letterSpacing: '0.06em',
                                            padding: '3px 8px',
                                            borderRadius: '4px',
                                            textTransform: 'uppercase',
                                          }}
                                        >
                                          VÍDEO · TREINAMENTO
                                        </div>
                                        <div
                                          style={{
                                            width: '52px',
                                            height: '52px',
                                            borderRadius: '50%',
                                            background: 'rgba(255,255,255,0.9)',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                          }}
                                        >
                                          <i
                                            className="material-icons-outlined"
                                            style={{
                                              fontSize: '32px',
                                              color: `${lbClient.primaryColor}`,
                                              marginLeft: '4px',
                                            }}
                                          >
                                            play_arrow
                                          </i>
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                </div>
                              );
                            })()}

                          {[
                            ...(landingBusiness?.medias?.supportMaterials ??
                              []),
                          ]
                            .sort((a, b) =>
                              a.type === 'youtube'
                                ? -1
                                : b.type === 'youtube'
                                  ? 1
                                  : 0
                            )
                            .map((material, index) => {
                              const isYoutube = material.type === 'youtube';
                              const videoId = isYoutube
                                ? material.url.match(
                                    /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/
                                  )?.[1]
                                : null;
                              const isPlaying =
                                playingMaterialUrl === material.url;
                              const embedUrl =
                                isYoutube && videoId
                                  ? getYouTubeEmbed(material.url, {
                                      controls: true,
                                      autoplay: true,
                                      mute: false,
                                      loop: false,
                                    })
                                  : null;

                              if (isYoutube && videoId) {
                                return (
                                  <div
                                    key={index}
                                    style={{
                                      marginBottom: '12px',
                                      borderRadius: '10px',
                                      overflow: 'hidden',
                                      border: '1px solid #e8d5bb',
                                    }}
                                  >
                                    {isPlaying && embedUrl ? (
                                      <div className="ratio ratio-16x9">
                                        <iframe
                                          src={embedUrl}
                                          title={material.name}
                                          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                          allowFullScreen
                                        />
                                      </div>
                                    ) : (
                                      <div
                                        style={{
                                          position: 'relative',
                                          cursor: 'pointer',
                                        }}
                                        onClick={() =>
                                          setPlayingMaterialUrl(material.url)
                                        }
                                      >
                                        <img
                                          src={`https://img.youtube.com/vi/${videoId}/hqdefault.jpg`}
                                          alt={material.name}
                                          style={{
                                            width: '100%',
                                            display: 'block',
                                            aspectRatio: '16/9',
                                            objectFit: 'cover',
                                          }}
                                        />
                                        <div
                                          style={{
                                            position: 'absolute',
                                            inset: 0,
                                            background:
                                              'linear-gradient(to bottom, rgba(0,0,0,0.35) 0%, rgba(0,0,0,0.55) 100%)',
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            gap: '8px',
                                          }}
                                        >
                                          <div
                                            style={{
                                              position: 'absolute',
                                              top: '10px',
                                              left: '10px',
                                              background:
                                                'rgba(255,255,255,0.18)',
                                              color: '#fff',
                                              fontSize: '10px',
                                              fontWeight: 700,
                                              letterSpacing: '0.06em',
                                              padding: '3px 8px',
                                              borderRadius: '4px',
                                              textTransform: 'uppercase',
                                            }}
                                          >
                                            VÍDEO · TREINAMENTO
                                          </div>
                                          <div
                                            style={{
                                              width: '52px',
                                              height: '52px',
                                              borderRadius: '50%',
                                              background:
                                                'rgba(255,255,255,0.9)',
                                              display: 'flex',
                                              alignItems: 'center',
                                              justifyContent: 'center',
                                            }}
                                          >
                                            <i
                                              className="material-icons-outlined"
                                              style={{
                                                fontSize: '32px',
                                                color: `${lbClient.primaryColor}`,
                                                marginLeft: '4px',
                                              }}
                                            >
                                              play_arrow
                                            </i>
                                          </div>
                                          {material.name && (
                                            <span
                                              style={{
                                                color: '#fff',
                                                fontSize: '13px',
                                                fontWeight: 600,
                                                textAlign: 'center',
                                                padding: '0 16px',
                                                textShadow:
                                                  '0 1px 3px rgba(0,0,0,0.6)',
                                              }}
                                            >
                                              {material.name}
                                            </span>
                                          )}
                                          {(material as any).duration && (
                                            <div
                                              style={{
                                                position: 'absolute',
                                                bottom: '10px',
                                                right: '10px',
                                                background: 'rgba(0,0,0,0.7)',
                                                color: '#fff',
                                                fontSize: '11px',
                                                fontWeight: 600,
                                                padding: '2px 6px',
                                                borderRadius: '4px',
                                              }}
                                            >
                                              {(material as any).duration}
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                );
                              }

                              return (
                                <div
                                  key={index}
                                  style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    padding: '10px',
                                    border: '1px solid #e8d5bb',
                                    borderRadius: '8px',
                                    marginBottom: '10px',
                                    background: '#fff',
                                  }}
                                >
                                  <span
                                    style={{ wordBreak: 'break-all', flex: 1 }}
                                  >
                                    {material.name ||
                                      (material.type === 'link'
                                        ? `Link ${index + 1}`
                                        : `Arquivo ${index + 1}`)}
                                  </span>
                                  <a
                                    href={material.url}
                                    download
                                    style={{
                                      marginLeft: '20px',
                                      padding: '6px 16px',
                                      background: `${lbClient.primaryColor}`,
                                      color: '#fff',
                                      border: 'none',
                                      borderRadius: '4px',
                                      fontSize: '14px',
                                      cursor: 'pointer',
                                      textDecoration: 'none',
                                    }}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    Acessar
                                  </a>
                                </div>
                              );
                            })}

                          {landingBusiness?.quizId && (
                            <div style={{ marginTop: '14px' }}>
                              <button
                                onClick={() =>
                                  navigate(
                                    `${routes.ACTION_DETAILS}/${landingBusiness.quizId}`
                                  )
                                }
                                style={{
                                  width: '100%',
                                  backgroundColor: `${lbClient.primaryColor}`,
                                  color: '#fff',
                                  border: 'none',
                                  borderRadius: '8px',
                                  padding: '11px 16px',
                                  fontSize: '14px',
                                  fontWeight: '600',
                                  cursor: 'pointer',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  gap: '6px',
                                }}
                              >
                                <i
                                  className="material-icons-outlined"
                                  style={{ fontSize: '18px' }}
                                >
                                  quiz
                                </i>
                                Ver vídeo e testar conhecimento
                              </button>
                            </div>
                          )}

                          <div
                            style={{
                              display: 'flex',
                              gap: '10px',
                              background: '#FFF4E4',
                              borderLeft: '4px solid #E8963A',
                              borderRadius: '8px',
                              padding: '12px 14px',
                              marginTop: '12px',
                            }}
                          >
                            <span style={{ fontSize: '18px', flexShrink: 0 }}>
                              ⚠️
                            </span>
                            <div>
                              <div
                                style={{
                                  fontWeight: 700,
                                  color: '#8A4B0C',
                                  fontSize: '12.5px',
                                  marginBottom: '3px',
                                }}
                              >
                                NÃO COMPARTILHÁVEL
                              </div>
                              <div
                                style={{
                                  color: '#6B5236',
                                  fontSize: '12px',
                                  lineHeight: 1.45,
                                }}
                              >
                                Este material é de acesso restrito ao time de
                                vendas e fica oculto do público-alvo na LP do
                                empreendimento.
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    {!playerId &&
                      landingBusiness?.quizId &&
                      !isAutoParam &&
                      !(
                        landingBusiness?.medias?.supportMaterials &&
                        (lbPlayer || player)?.regional === 'sim'
                      ) && (
                        <div
                          style={{
                            display: 'flex',
                            justifyContent: 'center',
                            marginTop: '16px',
                            marginBottom: '16px',
                          }}
                        >
                          <button
                            onClick={() =>
                              navigate(
                                `${routes.ACTION_DETAILS}/${landingBusiness.quizId}`
                              )
                            }
                            style={{
                              backgroundColor: `${lbClient.primaryColor}`,
                              color: '#fff',
                              border: 'none',
                              borderRadius: '8px',
                              padding: '12px 32px',
                              fontSize: '16px',
                              fontWeight: '600',
                              cursor: 'pointer',
                              width: window.innerWidth <= 768 ? '90%' : '100%',
                            }}
                          >
                            Responder o Quiz
                          </button>
                        </div>
                      )}
                    {!playerId &&
                      !isAutoParam &&
                      lbClient?.settings?.landingBusiness?.showShareButton !==
                        false && (
                        <div
                          style={{
                            textAlign: 'center',
                            margin: '22px 0 18px 0',
                          }}
                        >
                          <p
                            style={{
                              fontSize: '12px',
                              color: '#8A8A8A',
                              marginBottom: '10px',
                              padding: '0 20px',
                              lineHeight: 1.5,
                            }}
                          >
                            Chegou a sua vez: use a seção abaixo para gerar seu
                            próprio material de captação de leads.
                          </p>
                          <div
                            style={{
                              background: '#4C4C4C',
                              color: '#fff',
                              fontSize: '14.5px',
                              fontWeight: 700,
                              borderRadius: '10px',
                              padding: '13px',
                            }}
                          >
                            Gere seu material personalizado
                          </div>
                          <div
                            style={{
                              margin: '8px auto 0',
                              width: 0,
                              height: 0,
                              borderLeft: '9px solid transparent',
                              borderRight: '9px solid transparent',
                              borderTop: '10px solid #4C4C4C',
                            }}
                          />
                        </div>
                      )}
                    {!playerId &&
                      !isAutoParam &&
                      lbClient?.settings?.landingBusiness?.showShareButton !==
                        false && (
                        <div
                          style={{
                            background: '#F1FAF4',
                            border: '1.5px solid #C9E9D2',
                            borderRadius: '16px',
                            padding: '12px',
                          }}
                        >
                          <div
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: '6px',
                              fontSize: '11px',
                              fontWeight: 700,
                              color: '#1F7A3E',
                              textTransform: 'uppercase',
                              marginBottom: '12px',
                              letterSpacing: '0.04em',
                            }}
                          >
                            <span
                              style={{
                                width: '6px',
                                height: '6px',
                                borderRadius: '50%',
                                background: '#2FA857',
                                display: 'inline-block',
                                flexShrink: 0,
                              }}
                            />
                            Compartilhável · envie para seus clientes
                          </div>
                          <>
                            {lbClient?.clientUrl !== 'motamachado' && (
                              <div
                                style={{
                                  borderRadius: '10px',
                                  border:
                                    window.innerWidth <= 768
                                      ? null
                                      : '1px solid #dee2e6',
                                  borderTop: 'none',
                                  textAlign: 'center',
                                }}
                              >
                                <div
                                  style={{
                                    backgroundColor: `${lbClient.primaryColor}`,
                                    color: 'white',
                                    padding: '8px 24px',
                                    borderRadius:
                                      window.innerWidth <= 768
                                        ? '8px'
                                        : '8px 8px 0px 0px',
                                    fontSize:
                                      window.innerWidth <= 768
                                        ? '17px'
                                        : '20px',
                                    fontWeight: '500',
                                    textAlign: 'center',
                                    marginLeft: 'auto',
                                    marginRight: 'auto',
                                    width:
                                      window.innerWidth <= 768 ? '90%' : '100%',
                                  }}
                                >
                                  Compartilhar
                                </div>
                                <div className="container">
                                  <span style={{ fontSize: '13px' }}>
                                    Compartilhar rapidamente via
                                  </span>
                                  <div
                                    className="my-2"
                                    style={{ width: '90%', margin: 'auto' }}
                                  >
                                    <ShareButton action={landingBusiness} />
                                  </div>
                                  <span style={{ fontSize: '13px' }}>
                                    Ou copie o link
                                  </span>
                                  <div
                                    className="mt-2"
                                    style={{
                                      marginLeft: '16px',
                                      marginRight: '16px',
                                    }}
                                  >
                                    <div
                                      style={{
                                        display: 'flex',
                                        borderRadius: '30px',
                                        width: '100%',
                                        overflow: 'hidden',
                                        border: '1px solid #dee2e6',
                                      }}
                                    >
                                      <input
                                        className="px-4"
                                        placeholder="Link encurtado"
                                        value={landingBusiness?.shareUrl}
                                        disabled
                                        type="text"
                                        style={{
                                          outline: 'none',
                                          border: 'none',
                                          width: '100%',
                                          textAlign: 'center',
                                          fontSize: '16px',
                                        }}
                                      />
                                      <button
                                        onClick={() => {
                                          navigator.clipboard.writeText(
                                            landingBusiness?.shareUrl
                                          );
                                          Notify(
                                            'Texto copiado com sucesso',
                                            'success'
                                          );
                                        }}
                                        style={{
                                          fontSize: '20px',
                                          display: 'flex',
                                          alignItems: 'center',
                                          justifyContent: 'center',
                                          outline: 'none',
                                          border: 'none',
                                          width: '40px',
                                          height: '40px',
                                          borderRadius: '100%',
                                          backgroundColor: '#00000020',
                                        }}
                                        className="p-4"
                                      >
                                        <i className="material-icons-outlined">
                                          content_copy
                                        </i>
                                      </button>
                                    </div>
                                  </div>
                                  <div className="mt-2">
                                    <div
                                      ref={qrCodeRef}
                                      style={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        backgroundColor: '#fff',
                                        padding: '16px',
                                      }}
                                    >
                                      <QrcodeWithPdf
                                        valueQrcode={
                                          landingBusiness?.shareUrl
                                            ? landingBusiness.shareUrl
                                            : ''
                                        }
                                      />
                                      <div
                                        style={{
                                          marginTop: '6px',
                                          background: '#2d6a4f',
                                          color: '#fff',
                                          borderRadius: '20px',
                                          padding: '5px 14px',
                                          fontSize: '12px',
                                          fontWeight: 600,
                                          letterSpacing: '0.03em',
                                          textAlign: 'center',
                                        }}
                                      >
                                        GERADO PARA{' '}
                                        <span style={{ fontWeight: 800 }}>
                                          {player.name}
                                        </span>
                                      </div>
                                    </div>

                                    <div>
                                      <Button
                                        text="Baixar QRCode"
                                        style={{
                                          backgroundColor: `${lbClient.primaryColor}`,
                                          color: 'white',
                                          width: '100%',
                                        }}
                                        onClick={downloadQRCode}
                                      />
                                    </div>

                                    <span style={{ fontSize: '8px' }}>
                                      Se quiser indicar alguem sem compartilhar
                                      o link, gere o QRCode direto na sua tela.
                                      Basta seu indicado apontar a câmera do
                                      celular dele para o código e pronto.
                                    </span>
                                  </div>
                                </div>
                              </div>
                            )}
                            {!isAutoParam &&
                              lbClient?.clientUrl !== 'motamachado' && (
                                <div className="mt-3 mb-3">
                                  <div
                                    style={{
                                      borderRadius: '10px',
                                      padding: '20px',
                                      backgroundColor: `${lbClient.secondaryColor}`,
                                      backgroundImage: `url(${cartazBackground})`,
                                      backgroundSize: '130%',
                                      backgroundRepeat: 'no-repeat',
                                      backgroundPosition: 'bottom',
                                    }}
                                  >
                                    <div style={{ marginBottom: '15rem' }}>
                                      <p className="fw-semibold fs-4 d-flex align-items-center">
                                        <i className="material-icons-outlined me-2">
                                          new_releases
                                        </i>
                                        Baixe seu cartaz!
                                      </p>
                                      <p className="tiny-text">
                                        Agora você pode baixar e imprimir
                                        cartazes com as publicações, fixar a
                                        peça promocional em qualquer lugar e
                                        divulgar onde quiser!
                                      </p>
                                      <p className="tiny-text">
                                        Aproveite a novidade para aumentar sua
                                        captação de clientes, gerar novas
                                        oportunidades de negócios e ganhar cada
                                        vez mais! 😉
                                      </p>
                                      <div className="mt-4">
                                        <Button
                                          text="Baixar"
                                          color="primary"
                                          onClick={() =>
                                            setPosterModalIsOpen(true)
                                          }
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              )}
                          </>
                        </div>
                      )}
                  </div>
                </div>

                <div className="row" style={{ marginTop: '32px' }}>
                  {(landingBusiness.medias.videoUrl ||
                    landingBusiness.medias.virtualTourUrl) && (
                    <div className="col-sm-12 col-lg-6">
                      <div
                        style={{
                          borderRadius: '10px',
                          border:
                            window.innerWidth <= 768
                              ? null
                              : '1px solid #dee2e6',
                          position: 'relative',
                          marginBottom: '24px',
                        }}
                      >
                        <div
                          style={{
                            backgroundColor: `${lbClient.primaryColor}`,
                            color: 'white',
                            padding: '8px 24px',
                            marginBottom: '5px',
                            borderRadius:
                              window.innerWidth <= 768
                                ? '8px'
                                : '8px 8px 0px 0px',
                            fontSize:
                              window.innerWidth <= 768 ? '17px' : '25px',
                            textAlign: 'center',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                          }}
                        >
                          Mais sobre o empreendimento
                        </div>
                        <div
                          className="row"
                          style={{
                            margin: window.innerWidth <= 768 ? null : '10px',
                          }}
                        >
                          {landingBusiness.medias.images.blueprintImages && (
                            <div
                              className="col-sm-12 col-lg-6"
                              style={{ marginBottom: '5px' }}
                            >
                              <div
                                className="border rounded-4"
                                style={{ padding: '10px' }}
                              >
                                <span
                                  style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    paddingBottom: '5px',
                                    gap: '5px',
                                  }}
                                >
                                  <i className="material-icons-outlined">
                                    square_foot
                                  </i>
                                  Planta
                                </span>
                                <img
                                  src={
                                    landingBusiness.medias.images
                                      .blueprintImages[0]
                                  }
                                  style={{
                                    width: '100%',
                                    cursor: 'pointer',
                                    borderRadius: '8px',
                                  }}
                                  onClick={() => {
                                    setBlueprintModal(!blueprintModal);
                                    setImageModal(true);
                                  }}
                                />
                              </div>
                            </div>
                          )}
                          {landingBusiness.medias.virtualTourUrl && (
                            <div
                              className="col-sm-12 col-lg-6"
                              style={{ marginBottom: '5px' }}
                            >
                              <div
                                className="border rounded-4"
                                style={{ padding: '10px' }}
                              >
                                <span
                                  style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    paddingBottom: '5px',
                                    gap: '5px',
                                  }}
                                >
                                  <i className="material-icons-outlined">
                                    view_in_ar
                                  </i>
                                  3D Tour
                                </span>
                                {landingBusiness.medias?.virtualTourUrl?.includes(
                                  'youtube'
                                ) ? (
                                  <a
                                    className="border rounded-4"
                                    href={landingBusiness.medias.virtualTourUrl}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    <img
                                      src={`https://img.youtube.com/vi/${landingBusiness.medias?.virtualTourUrl?.match(/(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/)[1]}/hqdefault.jpg`}
                                      style={{
                                        width: '100%',
                                        cursor: 'pointer',
                                        borderRadius: '8px',
                                      }}
                                    />
                                  </a>
                                ) : (
                                  <div
                                    style={{
                                      position: 'relative',
                                      width: '100%',
                                      borderRadius: '8px',
                                    }}
                                  >
                                    <iframe
                                      src={
                                        landingBusiness.medias.virtualTourUrl
                                      }
                                      style={{
                                        width: '100%',
                                        height: '180px',
                                        borderRadius: '8px',
                                        pointerEvents: 'none',
                                      }}
                                      sandbox="allow-same-origin allow-scripts allow-forms allow-popups"
                                      referrerPolicy="no-referrer"
                                      allow="fullscreen; accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                    />
                                    <div
                                      onClick={() => setIFrameModal(true)}
                                      style={{
                                        position: 'absolute',
                                        top: 0,
                                        left: 0,
                                        width: '100%',
                                        height: '100%',
                                        cursor: 'pointer',
                                        opacity: 0,
                                      }}
                                    />
                                  </div>
                                )}
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  )}
                </div>

                {/* Recommendations */}
                <div
                  ref={recommendationsRef}
                  style={{
                    marginTop: '32px',
                  }}
                >
                  <h3
                    style={{
                      fontSize: '24px',
                      fontWeight: 'bold',
                    }}
                  >
                    Conheça outras oportunidades para você!
                  </h3>
                  <div
                    className="row"
                    style={{
                      display: 'flex',
                      gap: '16px',
                      marginTop: '16px',
                    }}
                  >
                    {filteredClientLandingBusiness?.length === 0 &&
                    (clientLandingBusiness?.length ?? 0) > 0 ? (
                      <div
                        ref={noResultsRef}
                        style={{
                          width: '100%',
                          maxWidth: '560px',
                          margin: '8px auto 0',
                          background: '#fff',
                          borderRadius: '16px',
                          border: '1.5px solid #e8e8e8',
                          padding: '32px 24px',
                          textAlign: 'center',
                        }}
                      >
                        <div
                          style={{
                            width: '64px',
                            height: '64px',
                            borderRadius: '50%',
                            background: '#F5F5F5',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            margin: '0 auto 16px',
                          }}
                        >
                          <i
                            className="material-icons-outlined"
                            style={{ fontSize: '36px', color: '#9E9E9E' }}
                          >
                            schedule
                          </i>
                        </div>
                        <h4
                          style={{
                            fontWeight: 700,
                            fontSize: '17px',
                            color: '#1F7A3E',
                            marginBottom: '8px',
                          }}
                        >
                          O imóvel que você deseja vai estar disponível em
                          breve!
                        </h4>
                        <p
                          style={{
                            color: '#666',
                            fontSize: '14px',
                            marginBottom: '24px',
                          }}
                        >
                          Para ficar sabendo em primeira mão, basta nos informar
                          estes dados:
                        </p>

                        {noResultsForm.submitted ? (
                          <div
                            style={{
                              background: '#F1FAF4',
                              border: '1.5px solid #C9E9D2',
                              borderRadius: '12px',
                              padding: '20px',
                              color: '#1F7A3E',
                              fontWeight: 600,
                              fontSize: '15px',
                            }}
                          >
                            <i
                              className="material-icons-outlined"
                              style={{
                                fontSize: '28px',
                                display: 'block',
                                marginBottom: '8px',
                              }}
                            >
                              check_circle
                            </i>
                            Ótimo! Entraremos em contato assim que houver
                            disponibilidade.
                          </div>
                        ) : (
                          <div
                            style={{
                              display: 'flex',
                              flexDirection: 'column',
                              gap: '12px',
                              textAlign: 'left',
                            }}
                          >
                            <input
                              type="text"
                              placeholder="Seu nome completo"
                              value={noResultsForm.name}
                              onChange={(e) =>
                                setNoResultsForm((f) => ({
                                  ...f,
                                  name: e.target.value,
                                }))
                              }
                              style={{
                                width: '100%',
                                border: '1.5px solid #ddd',
                                borderRadius: '8px',
                                padding: '11px 14px',
                                fontSize: '14px',
                                outline: 'none',
                                boxSizing: 'border-box',
                              }}
                            />
                            <input
                              type="tel"
                              placeholder="Tel. / WhatsApp (com DDD)"
                              value={noResultsForm.phone}
                              inputMode="numeric"
                              autoComplete="tel-national"
                              onChange={(e) => {
                                const phone = maskPhoneBR(e.target.value);
                                setNoResultsForm((f) => ({ ...f, phone }));
                              }}
                              onBlur={() => setNoResultsPhoneTouched(true)}
                              aria-invalid={
                                noResultsPhoneTouched &&
                                !!noResultsForm.phone &&
                                !isValidPhoneBR(noResultsForm.phone)
                              }
                              style={{
                                width: '100%',
                                border:
                                  noResultsPhoneTouched &&
                                  !!noResultsForm.phone &&
                                  !isValidPhoneBR(noResultsForm.phone)
                                    ? '1.5px solid #c62828'
                                    : '1.5px solid #ddd',
                                borderRadius: '8px',
                                padding: '11px 14px',
                                fontSize: '14px',
                                outline: 'none',
                                boxSizing: 'border-box',
                              }}
                            />
                            {noResultsPhoneTouched &&
                              !!noResultsForm.phone &&
                              !isValidPhoneBR(noResultsForm.phone) && (
                                <span
                                  style={{
                                    color: '#c62828',
                                    fontSize: '12px',
                                    marginTop: '-6px',
                                  }}
                                >
                                  Telefone inválido. Use o formato (11)
                                  98877-6655 ou (11) 8877-6655.
                                </span>
                              )}
                            <label
                              style={{
                                display: 'flex',
                                alignItems: 'flex-start',
                                gap: '10px',
                                fontSize: '12px',
                                color: '#555',
                                cursor: 'pointer',
                              }}
                            >
                              <input
                                type="checkbox"
                                checked={noResultsForm.consent}
                                onChange={(e) =>
                                  setNoResultsForm((f) => ({
                                    ...f,
                                    consent: e.target.checked,
                                  }))
                                }
                                style={{ marginTop: '2px', flexShrink: 0 }}
                              />
                              <span>
                                De acordo com as Leis 12.965/2014 e 13.709/2018,
                                que regulam o uso da Internet e o tratamento de
                                dados pessoais no Brasil, ao me inscrever
                                autorizo a{' '}
                                <strong>{lbClient?.companyName}</strong> a
                                enviar notificações por e-mail ou outros meios
                                de acordo com a sua{' '}
                                <a
                                  href="https://firebasestorage.googleapis.com/v0/b/oqhomapi.appspot.com/o/TermsAndPolitics%2FPOLI%CC%81TICA%20DE%20PRIVACIDADE%20LGPD%20COMPLIANCE%202026.pdf?alt=media&token=f6339049-9c75-4ac2-8417-a70c9d75be94"
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  style={{ color: lbClient?.primaryColor }}
                                >
                                  Política de Privacidade
                                </a>{' '}
                                e{' '}
                                <a
                                  href={`${window.location.origin}${routes.TERMS}`}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  style={{ color: lbClient?.primaryColor }}
                                >
                                  Termos de Uso
                                </a>
                                .
                              </span>
                            </label>
                            <button
                              onClick={saveNoResultsLead}
                              disabled={
                                noResultsForm.submitting ||
                                !noResultsForm.name ||
                                !isValidPhoneBR(noResultsForm.phone) ||
                                !noResultsForm.consent
                              }
                              style={{
                                width: '100%',
                                backgroundColor:
                                  noResultsForm.submitting ||
                                  !noResultsForm.name ||
                                  !isValidPhoneBR(noResultsForm.phone) ||
                                  !noResultsForm.consent
                                    ? '#ccc'
                                    : lbClient?.primaryColor,
                                color: '#fff',
                                border: 'none',
                                borderRadius: '8px',
                                padding: '12px',
                                fontSize: '14px',
                                fontWeight: 700,
                                letterSpacing: '0.04em',
                                cursor:
                                  noResultsForm.submitting ||
                                  !noResultsForm.name ||
                                  !isValidPhoneBR(noResultsForm.phone) ||
                                  !noResultsForm.consent
                                    ? 'not-allowed'
                                    : 'pointer',
                                textTransform: 'uppercase',
                              }}
                            >
                              {noResultsForm.submitting
                                ? 'Enviando...'
                                : 'Permitir contato'}
                            </button>
                          </div>
                        )}
                      </div>
                    ) : (
                      recommendations.visible.map((Lb, index) => (
                        <div
                          key={index}
                          className="col-lg-3 pt-3"
                          style={{
                            border: '1px solid #ddd',
                            borderRadius: '8px',
                            overflow: 'hidden',
                          }}
                        >
                          <img
                            src={Lb.thumbnail}
                            alt={Lb.name}
                            style={{
                              width: '100%',
                              height: '192px',
                              objectFit: 'cover',
                            }}
                          />
                          <div
                            style={{
                              padding: '16px',
                            }}
                          >
                            <h4
                              style={{
                                fontWeight: 'bold',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                              }}
                            >
                              {Lb.name}
                            </h4>
                            <p
                              style={{
                                color: '#666',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap',
                                overflow: 'auto',
                              }}
                            >
                              {Lb.city}
                            </p>
                            <button
                              style={{
                                width: '100%',
                                backgroundColor: `${lbClient.primaryColor}`,
                                color: 'white',
                                padding: '12px',
                                borderRadius: '4px',
                                border: 'none',
                                marginTop: '16px',
                                cursor: 'pointer',
                                fontSize: '20px',
                              }}
                              onClick={() => {
                                window.open(
                                  `${routes.LANDING_BUSSINESS}/${Lb.id}/${lbPlayer.id}`
                                );
                              }}
                            >
                              Ver mais
                            </button>
                          </div>
                        </div>
                      ))
                    )}
                  </div>
                  {recommendations.hasMore && (
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'center',
                        marginTop: '24px',
                      }}
                    >
                      <button
                        style={{
                          backgroundColor: 'white',
                          color: `${lbClient.primaryColor}`,
                          padding: '12px 32px',
                          borderRadius: '4px',
                          border: `1px solid ${lbClient.primaryColor}`,
                          cursor: 'pointer',
                          fontSize: '16px',
                          fontWeight: 600,
                        }}
                        onClick={() => setShowAllRecommendations(true)}
                      >
                        Carregar mais
                      </button>
                    </div>
                  )}
                </div>
                {/* Footer */}
                <footer
                  style={{
                    marginTop: '32px',
                    padding: '16px',
                    textAlign: 'center',
                    fontSize: '14px',
                    color: '#666',
                    borderTop: '1px solid #eee',
                  }}
                >
                  <div
                    style={{
                      display: 'flex',
                      flexDirection:
                        window.innerWidth <= 768 ? 'column' : undefined,
                      justifyContent: 'center',
                      gap: '16px',
                      marginBottom: '16px',
                    }}
                  >
                    <a
                      href="https://firebasestorage.googleapis.com/v0/b/oqhomapi.appspot.com/o/TermsAndPolitics%2FPOLI%CC%81TICA%20DE%20PRIVACIDADE%20LGPD%20COMPLIANCE%202026.pdf?alt=media&token=f6339049-9c75-4ac2-8417-a70c9d75be94"
                      style={{
                        color: '#666',
                        textDecoration: 'none',
                      }}
                      target="_blank"
                    >
                      Política de privacidade
                    </a>
                    <a
                      onClick={() =>
                        navigate(`${routes.TERMS}`, {
                          state: {
                            isCameFromActionPage: true,
                            clientId: lbClient?.id,
                          },
                        })
                      }
                      style={{
                        color: '#666',
                        textDecoration: 'none',
                      }}
                    >
                      Termos de uso
                    </a>
                    <a
                      href="#"
                      style={{
                        color: '#666',
                        textDecoration: 'none',
                      }}
                    >
                      Empreendimentos
                    </a>
                  </div>
                  <a
                    href="https://oqindicar.com/"
                    target="_blank"
                    style={{
                      textDecoration: 'none',
                    }}
                  >
                    © {new Date().getFullYear()} OQ Digital, Todos os direitos
                    reservados
                  </a>
                </footer>
              </>
            )}
          </div>
        </>
      )}
      {playerId && (
        <WhatsAppCapture
          data={(e: any) => {
            saveLead({
              leadName: e.name,
              lastname: '',
              leadPhone: e.phone,
              leadEmail: e.email,
            });
          }}
          isOpen={isOpenWhatsAppCapture}
          client={lbClient}
          player={lbPlayer}
          host={{}}
          termsUrl={`${routes.TERMS}?clientId=${lbClient?.id}`}
        />
      )}
      <IFrameModal
        url={landingBusiness?.medias?.virtualTourUrl}
        modalIsOpen={iFrameModal}
        toggleModal={() => {
          setIFrameModal(false);
        }}
      />
      <ImageModal
        images={
          blueprintModal
            ? landingBusiness.medias.images.blueprintImages
            : images
        }
        modalIsOpen={imageModal}
        toggleModal={() => {
          setImageModal(false);
          setBlueprintModal(false);
        }}
      />
      <ShareModal
        landingBusiness={landingBusiness}
        client={lbClient}
        modalIsOpen={shareModal}
        toggleModal={() => {
          setShareModal(false);
        }}
      />
      <ModalPosterPrint
        modalIsOpen={posterModalIsOpen}
        closeModal={() => setPosterModalIsOpen(false)}
        clientPrimaryColor={(lbClient || client)?.primaryColor || ''}
        playerName={(lbPlayer || player)?.name || ''}
        action={{
          id: landingBusiness?.id,
          shareUrl: landingBusiness?.shareUrl || '',
          actionTitle: landingBusiness?.details?.name || '',
          images: cartazCover?.imgBase64 || undefined,
          defaultImagePoster: cartazCover?.imgBase64 || undefined,
        }}
        shareUrl={landingBusiness?.shareUrl || ''}
        actionImagesBase64={cartazCover?.imgBase64 || ''}
        cartazCover={cartazCover || {}}
        isLandingBusiness={true}
        landingBusiness={landingBusiness}
        playerPhone={(lbPlayer || player)?.phoneNumber || ''}
        playerPhoto={playerPhotoBase64 || (lbPlayer || player)?.photoURL}
        playerRating={rating?.averageRating}
        imagesBase64={cartazImagesBase64}
        showPlayerContact={!landingBusiness?.settings?.anonymous}
        condominiumImageUrls={cartazCover?.imageUrls}
        selectedCoverIndex={selectedCoverIndex}
        onSelectCoverImage={setSelectedCoverIndex}
      />
      <ModalContact
        modalIsOpen={contactModalIsOpen}
        toggleModal={() => {
          setContactModalIsOpen(false);
          setLeadName('');
          setLeadLastName('');
          setLeadPhone('');
          setLeadPhoneTouched(false);
          setLeadEmail('');
          setLeadCpf('');
          setLead(undefined);
        }}
        companyName={lbClient?.companyName}
        player={lbPlayer}
        actionMgm={lbClient?.redirectForPlayer}
        actionMgmCta={lbClient?.btnRedirectTextForPlayer}
        actionMgmRedirect={`${routes.REGISTER}?business=${landingBusiness?.id}&client=${lbClient?.id}&player=${hostId}`}
        postRating={(e) =>
          postRating(bussinessId, lead.id, playerId, Number(e))
        }
        showEvaluation={lbClient?.redirectUrlLead}
        onRegisterWithAi={
          !signed && isAiSignupAvailable(lbClient)
            ? () => setAiSignupOpenRequest((n) => n + 1)
            : undefined
        }
      />
      {!signed && lbClient && (
        <AiSignup
          client={lbClient}
          prefill={aiSignupPrefill}
          hostId={hostId}
          openRequest={aiSignupOpenRequest}
          launcherOnlyAfterStart
          onLogin={() => navigate(`${routes.UNDERLINE}/${lbClient.clientUrl}`)}
        />
      )}
    </div>
  );
}
